window.theme = window.theme || {};

/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).off('focusin');

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    if(src.indexOf('@') != -1){
      var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)?\@\d{1,2}x|\d{1,4}x\d{0,4}?@\d{1,2}x|x\d{1,4}?\@\d{1,2}x)[_\.@]/);
    }else{
      var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
    }
    if (match !== null) {
      return match[1];
    } else {
      return null;
    }
  }
  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size == null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match != null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  function getName(path) {
    return _.first(_.last(path.split('/')).split('.'));
  }

  function bgSet(imgOjb) {
    var image = imgOjb;
    var url = image.src;
    var fileExt = _.last(url.split('.'));
    var aspect_ratio = image.width/image.height;
    var bgurl = '';
    bgurl += image.width > 180 ? theme.Images.removeProtocol(url.replace('.'+fileExt, '_180x.'+fileExt))+' 180w '+ Math.round(180 / aspect_ratio) +'h,' : '';
    bgurl += image.width > 360 ? theme.Images.removeProtocol(url.replace('.'+fileExt, '_360x.'+fileExt))+' 360w '+ Math.round(360 / aspect_ratio) +'h,' : '';
    bgurl += image.width > 540 ? theme.Images.removeProtocol(url.replace('.'+fileExt, '_540x.'+fileExt))+' 540w '+ Math.round(540 / aspect_ratio) +'h,' : '';
    bgurl += image.width > 720 ? theme.Images.removeProtocol(url.replace('.'+fileExt, '_720x.'+fileExt))+' 720w '+ Math.round(720 / aspect_ratio) +'h,' : '';
    bgurl += image.width > 900 ? theme.Images.removeProtocol(url.replace('.'+fileExt, '_900x.'+fileExt))+' 900w '+ Math.round(900 / aspect_ratio) +'h,' : '';
    bgurl += image.width > 1080 ? theme.Images.removeProtocol(url.replace('.'+fileExt, '_1080x.'+fileExt))+' 1080w '+ Math.round(1080 / aspect_ratio) +'h,' : '';
    bgurl += image.width > 1296 ? theme.Images.removeProtocol(url.replace('.'+fileExt, '_1296x.'+fileExt))+' 1296w '+ Math.round(1296 / aspect_ratio) +'h,' : '';
    bgurl += image.width > 1512 ? theme.Images.removeProtocol(url.replace('.'+fileExt, '_1512x.'+fileExt))+' 1512w '+ Math.round(1512 / aspect_ratio) +'h,' : '';
    bgurl += image.width > 1728 ? theme.Images.removeProtocol(url.replace('.'+fileExt, '_1728x.'+fileExt))+' 1728w '+ Math.round(1728 / aspect_ratio) +'h,' : '';
    bgurl += image.width > 1950 ? theme.Images.removeProtocol(url.replace('.'+fileExt, '_1950x.'+fileExt))+' 1950w '+ Math.round(1950 / aspect_ratio) +'h,' : '';
    bgurl += image.width > 2100 ? theme.Images.removeProtocol(url.replace('.'+fileExt, '_2100x.'+fileExt))+' 2100w '+ Math.round(2100 / aspect_ratio) +'h,' : '';
    bgurl += image.width > 2260 ? theme.Images.removeProtocol(url.replace('.'+fileExt, '_2260x.'+fileExt))+' 2260w '+ Math.round(2260 / aspect_ratio) +'h,' : '';
    bgurl += image.width > 2450 ? theme.Images.removeProtocol(url.replace('.'+fileExt, '_2450x.'+fileExt))+' 2450w '+ Math.round(2450 / aspect_ratio) +'h,' : '';
    bgurl += image.width > 2700 ? theme.Images.removeProtocol(url.replace('.'+fileExt, '_2700x.'+fileExt))+' 2700w '+ Math.round(2700 / aspect_ratio) +'h,' : '';
    bgurl += image.width > 3000 ? theme.Images.removeProtocol(url.replace('.'+fileExt, '_3000x.'+fileExt))+' 3000w '+ Math.round(3000 / aspect_ratio) +'h,' : '';
    bgurl += image.width > 3350 ? theme.Images.removeProtocol(url.replace('.'+fileExt, '_3350x.'+fileExt))+' 3350w '+ Math.round(3350 / aspect_ratio) +'h,' : '';
    bgurl += image.width > 3750 ? theme.Images.removeProtocol(url.replace('.'+fileExt, '_3750x.'+fileExt))+' 3750w '+ Math.round(3750 / aspect_ratio) +'h,' : '';
    bgurl += image.width > 4100 ? theme.Images.removeProtocol(url.replace('.'+fileExt, '_4100x.'+fileExt))+' 4100w '+ Math.round(4100 / aspect_ratio) +'h,' : '';
    bgurl += imgOjb.src+' '+ image.width+'w '+image.height+'h';
    return bgurl;
  }
  function imgFit(width, height) {
    var fit = '';
    var aspect_ratioW = parseFloat(theme.strings.aspect_ratio.split('/')[0]),
        aspect_ratioH = parseFloat(theme.strings.aspect_ratio.split('/')[1]),
        aspect_cs = aspect_ratioW / aspect_ratioH;
    var aspect_image = width * 1.00 / height;
    if (aspect_ratioW < aspect_ratioH){
      if (width == height ){
        fit = "nonheight_ nonwidth";
      }
      else{
        if (aspect_cs >= aspect_image ){
          fit = "nonheight";
        } else {
          fit = "nonwidth";
        }
      }
    } else if (aspect_ratioW > aspect_ratioH){
      if (width == height ){
        fit = "nonheight nonwidth_";
      } else{
        if (aspect_cs <= aspect_image ){
          fit = "nonwidth";
        } else {
          fit = "nonheight";
        }
      }
    } else {
      fit = "nonheight nonwidth_";
    }
    return fit;
  }
  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol,
    getName: getName,
    bgSet: bgSet,
    imgFit: imgFit
  };
})();

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function c(h, i) {
      return(typeof h == "undefined" ? i : h)
    }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = c(precision, 2);
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  }
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
    this.template = this.originalSelectorId.replace('#ProductSelect-','');

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = _.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {

      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = _.find(variants, function(variant) {
        return selectedValues.every(function(values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      if($('.color_sw.selected .swatch').length != 0){
        var firstVariantImage = $('.color_sw.selected .swatch').css( 'background-image' ).replace('_small_crop_center','').replace(/(url\(|\)|'|")/gi, '');
      }
      var variantImage = variant.featured_image || {};
      var currentVariantImage = $('.product-single__photos-'+this.template + '.SlickPhotoswipGallery .slick-current').attr('data-src') || {};
      if (!variant.featured_image && firstVariantImage == undefined || variantImage.src === currentVariantImage && firstVariantImage == undefined) {
        return;
      }
      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
      
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }
      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
})();


/* ================ GLOBAL ================ */

window.theme = theme || {}; 

theme.getScrollbarWidth = (function(){
  var $inner = jQuery('<div style="width: 100%; height:200px;">test</div>'),
      $outer = jQuery('<div style="width:200px;height:150px; position: absolute; top: 0; left: 0; visibility: hidden; overflow:hidden;"></div>').append($inner),
      inner = $inner[0],
      outer = $outer[0];
  $('body').append(outer);
  var width1 = inner.offsetWidth;
  $outer.css('overflow', 'scroll');
  var width2 = outer.clientWidth;
  $outer.remove();
  return (width1 - width2);
});

/* ================ MODULES ================ */
window.theme = window.theme || {};

theme.MenuReposive = (function() {
  var selectors = {
    body: 'body',
    navigation: '.main-navigation',
    siteNavHasDropdown: '.site-nav--has-dropdown',
    siteNavChildLinks: '.site-nav__child-link',
    siteNavActiveDropdown: '.show-submenu',
    siteNavLinkMain: '.site-nav__link--main'
  };

  var config = {
    activeClass: 'show-submenu',
    childLinkClass: 'site-nav__child-link'
  };
  
  function is_mobile(){
    var isMobile = false;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Opera Mobile|Kindle|Windows Phone|PSP|AvantGo|Atomic Web Browser|Blazer|Chrome Mobile|Dolphin|Dolfin|Doris|GO Browser|Jasmine|MicroB|Mobile Firefox|Mobile Safari|Mobile Silk|Motorola Internet Browser|NetFront|NineSky|Nokia Web Browser|Obigo|Openwave Mobile Browser|Palm Pre web browser|Polaris|PS Vita browser|Puffin|QQbrowser|SEMC Browser|Skyfire|Tear|TeaShark|UC Browser|uZard Web|wOSBrowser|Yandex.Browser mobile/i.test(navigator.userAgent)) isMobile = true;
    return isMobile;
  }
  function init(){
    if(theme.MenuReposive.is_mobile() == false){
      $(document).on('mouseenter','.kt-nav '+selectors.siteNavHasDropdown,function(){
        if($(this).hasClass(config.activeClass) == false ){$(this).addClass(config.activeClass);}
      })
      $(document).on('mouseleave','.kt-nav '+selectors.siteNavHasDropdown,function(){
        if($(this).hasClass(config.activeClass)){$(this).removeClass(config.activeClass);}
      })
    }
  }
  
  function unload() {
    $(window).off(selectors.siteNavHasDropdown+' a');
    $(selectors.siteNavHasDropdown).off(selectors.siteNavHasDropdown+' a');
    $(selectors.body).off(selectors.siteNavHasDropdown+' a');
  }
  
  /* ---------------------------------------------
   Height Full
   --------------------------------------------- */
  function js_height_full(){
    var height = $(window).outerHeight();
    $(".full-height").css("height",height);
  }
  function js_width_full(){
    var width = $(window).outerWidth();
    $(".full-width").css("width",width);
  }
  function js_right_follow(headId){
    $.each($(headId + " .nowrap-follow-right"), function() {
      var dataMargin = $(this).children().attr('data-margin');
      $(this).children().css({"margin-left": +dataMargin * -1 + 'rem',"margin-right": +dataMargin * -1 + 'rem'});
      var width = $(this).width();
      mg = $(this).children().width() - width;
      if (mg > 0 && $(window).innerWidth() > 1200) {
        if ($('html').attr('dir') === 'ltr') {
          $(this).children().css("margin-left", mg * -1);
        }else{
          $(this).children().css("margin-right", mg * -1);
        }
      }
      $(this).removeClass('loading');
    });
  }
 
  function clone_main_menu() {
    var _clone_menu = $('#header .clone-main-menu'),
        _target = $('#box-mobile-menu .clone-main-menu'),
        _data_width = $('#header .main-navigation').data('width');
    if ($(window).innerWidth() <= _data_width) {
      if (_clone_menu.length > 0) {
        _clone_menu.each(function () {
          $(this).appendTo('#box-mobile-menu .box-inner');
        });
      }
      if ($('#header').hasClass('boxMbRun') == false) {
        $('#header').addClass('boxMbRun');
        box_mobile_menu();
      }
    } else {
      if (_target.length > 0) {
        _target.each(function () {
          $(this).appendTo('#header .main-navigation').clone();
          // .appendTo('#header-ontop .main-navigation');
        });
      }
    }

    function action_addClass() {
      $('body').addClass('box-mobile-menu-open');
      $('#bg-overlay').addClass('menu-mb-overlay').removeClass('menu-overlay');
      $('body').css({overflow:'hidden',paddingRight: theme.getScrollbarWidth()});
      return false;
    }

    function action_removeClass() {
      $('body').removeClass('box-mobile-menu-open');        
      $('body').css({overflow:'',marginRight:''});
      anime({targets: '#bg-overlay.menu-mb-overlay',backgroundColor: 'rgba(0,0,0,0)', duration: 300,easing: 'linear',complete: function(anim) {
        $('#bg-overlay').removeAttr('style class');
        $('body').removeAttr('data-scroll-top');
      }})
      return false;
    }

    $(document).on('click', ".menu-toggle", function(){
      action_addClass();
    })
    $(document).on('click touchstart', "#box-mobile-menu .close-menu, #bg-overlay.menu-mb-overlay", function(){
      action_removeClass();
    })
  }

  function box_mobile_menu() {
    var _content = $('#box-mobile-menu .clone-main-menu'),
        _data_width = $('#header .main-navigation').data('width');
    if ($(window).innerWidth() <= _data_width) {
      _content.each(function () {
        var t = $(this);
        t.addClass('active');
        $(this).find('.toggle-submenu').on('click', function () {
          t.removeClass('active');
          var text_next = $(this).parent().find('a').first().text();
          if ($(this).parent().find('a .label-menu').length) {
            text_next = text_next.replace($(this).prev().find('.label-menu').text(),'');
          }
          $('#box-mobile-menu .box-title').html(text_next);
          t.find('li').removeClass('mobile-active');
          $(this).parent().addClass('mobile-active');
          $(this).parent().closest('.sub-menu').css({
            'position': 'static',
            'height': '0',
          });
          $('#box-mobile-menu #back-menu').css('display', 'block');
        })
      });
      $('#box-mobile-menu #back-menu').on('click', function () {
        _content.find('li.mobile-active').each(function () {
          _content.find('li').removeClass('mobile-active');
          if ($(this).parent().hasClass('main-menu')) {
            _content.addClass('active');
            $('#box-mobile-menu .box-title').html('MAIN MENU');
            $('#box-mobile-menu #back-menu').css('display', 'none');
          } else {
            _content.removeClass('active');
            $(this).parent().parent().addClass('mobile-active');
            $(this).parent().css({
              'position': 'absolute',
              'height': 'auto',
            });
            var text_prev = $(this).parent().parent().children('a').text();
            $('#box-mobile-menu .box-title').html(text_prev);
          }
        })
      });
    }
    $('.mobile-navigation').on('click', function () {
      $('body').addClass('box-mobile-menu-open');
    });
    $('#box-mobile-menu .close-menu, .body-overlay').on('click', function () {
      $('body').removeClass('box-mobile-menu-open');
    });
  }

  function clone_header_ontop(){
    var width = $(window).width();
    if(width >= 375){
      if( $('#header').length > 0 && $('#header-ontop').length > 0 && $('#header-ontop').hasClass('is-sticky') && $('#header-ontop .header').length <= 0){
        var content = $("#header").clone();
        content.find(".nowrap-follow-right").addClass('loading').children().removeAttr('style');
        content.removeAttr('id');
        content.appendTo("#header-ontop");
        content.find(".not-sticky").remove();
        $.each(content.find('[id*="Carousel-"]'), function(index, val) {
          $(this).attr({'id': $(this).attr('id')+'-top','data-section-id': $(this).attr('data-section-id')+'-top'});
           $(this).find('.owl-carousel').each(function(){
            var owl = $(this);
            owl.trigger('refresh.owl.carousel');
          })
        });
        theme.ResizeNavMega.init('header-ontop');
        setTimeout(function(){
          theme.MenuReposive.js_right_follow('#header-ontop');
        },200)
      }else{
        setTimeout(function(){
          theme.MenuReposive.js_right_follow('#header-ontop');
        },200)
      }
      theme.Carousel.init($('[data-section-id="header"]')[0],true)
    }else{
      $('#header-ontop').html('');
      return false;
    }
  }
  return {
    init: init,
    is_mobile: is_mobile,
    js_height_full: js_height_full,
    js_width_full: js_width_full,
    js_right_follow: js_right_follow,
    clone_main_menu: clone_main_menu,
    box_mobile_menu: box_mobile_menu,
    clone_header_ontop: clone_header_ontop,
    unload: unload
  };
})();

window.theme = window.theme || {};

theme.StickyMenu = (function() {
  var selectors = {
    headerId: '#header',
    headerTop: '.header-top',
    headerAnnouncement: '.header-announcement',
    headerClassProp: '.header',
    stickyHeaderTop: '#header-ontop'
  };
  function init(){
    if($(selectors.headerId).length > 0 && $(window).width() >= 375){
      var previousScroll = 0,currentScroll = 0,
          headerOrgOffset = $(selectors.headerId+selectors.headerClassProp).offset().top + $(selectors.headerId+selectors.headerClassProp).outerHeight(),
          wrapStickOrgOffset = $(selectors.headerId).offset().top;
      $(window).scroll(function () {
        currentScroll = $(this).scrollTop();
        var headerTopHeight = $(selectors.stickyHeaderTop+' '+selectors.headerTop).outerHeight() || 0;
        var headerTopAnnouncement = $(selectors.stickyHeaderTop+' '+selectors.headerAnnouncement).outerHeight() || 0;
        if (currentScroll > headerOrgOffset && $(window).width() >= 375 && $('body').hasClass('onsticky') === false) {
          $('body').addClass('onsticky');
          if ($(selectors.headerTop).data('sticky') || $(selectors.headerAnnouncement).data('sticky')) {
            $(selectors.stickyHeaderTop+' '+selectors.headerClassProp).css('margin-top', (headerTopHeight * -1) + (headerTopAnnouncement * -1));
          }
          theme.DropdownReposive.init('.kiti--DropWindow','.header-control .kiti--DropItem','.kiti--DropInner');
        }
        else if(currentScroll <= headerOrgOffset && $('body:not(.onhide)').hasClass('onsticky')) {
          $('body').addClass('onhide');
          anime({targets: selectors.stickyHeaderTop+' .header', top: -100, opacity: 0, duration: 150,easing: 'linear',complete: function(anim) {
            $(selectors.stickyHeaderTop+' .header').css({'top': '', opacity: ''});
            $('body').removeClass('onsticky onhide onup');
          }});
        }
        if ($(selectors.headerTop).data('sticky') || $(selectors.headerAnnouncement).data('sticky')) {
          if(previousScroll > currentScroll + 10 && $('body:not(.onhide)').hasClass('onsticky') && $('body').hasClass('onup') === false){
            anime({targets: selectors.stickyHeaderTop+' '+selectors.headerClassProp, marginTop: 0, duration: 300,easing: 'linear'});
            $('body').addClass('onup');
          } else if(previousScroll <= currentScroll && $('body:not(.onhide)').hasClass('onsticky') && $('body').hasClass('onup')){
            anime({targets: selectors.stickyHeaderTop+' '+selectors.headerClassProp, marginTop: (headerTopHeight * -1) + (headerTopAnnouncement * -1), duration: 150,easing: 'linear'});
            $('body').removeClass('onup');
          }
        }
        previousScroll = currentScroll;
      });
    }
  }
  return {
    init: init
  };
})(jQuery);

window.theme = window.theme || {};

theme.ResizeNavMega = (function() {
  function init(headId){
    var selectors = {
      headerIsVisible: headId !== undefined ? '#header-ontop .main-header' : '#header .main-header',
      itemMega: '.item-megamenu',
      contentItemMega: '.sub-menu'
    };
    var window_size = jQuery('body').innerWidth();
    window_size += theme.getScrollbarWidth();
    var _data_width = $('#header .main-navigation').data('width'),
        _data_layout = $('#header .main-navigation').data("layout")
    if( window_size > _data_width ){
      if( $(selectors.headerIsVisible).length >0){
        var container = $(selectors.headerIsVisible);
        if( container!= 'undefined'){
          var container_width = 0;
          container_width = container.innerWidth();
          var container_offset = container.offset();
          var container_left = container_offset.left;
          var container_right = (container_left + container_width);
          if (_data_layout === 'vertical'){
            $(selectors.headerIsVisible+' .menu-item[data-block]').each(function(index,element){
              if ($(element).children('.sub-menu').length > 0) {
                var sub_menu_height = $(element).children('.sub-menu').outerHeight();
                var sub_menu_top = $(element).children('.sub-menu').offset().top;
                var item_top = $(element).offset().top;
                if(sub_menu_top + sub_menu_height - 20 <= item_top){
                  if(index <= $(selectors.headerIsVisible+' .item-menu').length / 2){
                    $(element).css('position', 'relative');
                  } else if(index > $(selectors.headerIsVisible+' .item-menu').length / 2){
                    $(element).css('position', 'relative').children('.sub-menu').css({'bottom': 0,'top': 'auto', 'max-height': 'none'});
                  }
                }
              }
            });
          }
          setTimeout(function(){
            $(selectors.headerIsVisible+' '+selectors.itemMega).each(function(index,element){
              if (_data_layout !== 'vertical') {
                $(element).children(selectors.contentItemMega).css({'max-width':container_width+'px'});
                var sub_menu_width = $(element).children(selectors.contentItemMega).outerWidth();
                var item_width = $(element).outerWidth();
                $(element).children(selectors.contentItemMega).css({'left':'-'+(sub_menu_width/2 - item_width/2)+'px'});
                var item_left = $(element).offset().left;
                var overflow_left = (sub_menu_width/2 > (item_left - container_left));
                var overflow_right = ((sub_menu_width/2 + item_left) > container_right);
                if( overflow_left ){
                  var left = (item_left - container_left);
                  $(element).children(selectors.contentItemMega).css({'left':-left+'px'});
                }
                if( overflow_right && !overflow_left ){
                  var left = (item_left - container_left);
                  left = left - (container_width - sub_menu_width);
                  $(element).children(selectors.contentItemMega).css({'left':-left+'px'});
                }
              }
              else if (_data_layout === 'vertical'){
                $(element).children(selectors.contentItemMega).css('max-width',$(window).width() - $(selectors.headerIsVisible+' .menuVeticalResize').offset().left);
                $(selectors.headerIsVisible+' .menuVeticalResize').css('height',$(window).height() - ($(selectors.headerIsVisible+' .menuVeticalResize').offset().top - $(window).scrollTop()));
              }
            })
            $(selectors.headerIsVisible+' .drop_to_right').each(function(index,element){
              var item_left = $(element).offset().left;
              var overflow_left = (550 > (item_left - container_left));
              var overflow_right = ((550 + item_left) > container_right);
              if( overflow_left ){
                var left = (item_left - container_left);
                $(element).addClass('drop_to_right').removeClass('drop_to_left');
              }
              if( overflow_right && !overflow_left ){
                $(element).addClass('drop_to_left').removeClass('drop_to_right');
              }
            });
          },100);
        }
      }
    }
  }
  return {
    init: init
  };
})(jQuery);

window.theme = window.theme || {};

theme.DropdownReposive = (function() {
  function init(window,item,box){
    var selectors = {
      headerIsVisibleDesktop: '.kiti-DropWindowDesktop',
      headerIsVisible: window,
      itemMega: item,
      contentItemMega: box
    };
    var window_size = jQuery('body').innerWidth();
    window_size += theme.getScrollbarWidth();
    if(theme.MenuReposive.is_mobile() === true){
      $(selectors.itemMega).addClass('kiti-DropisMobile').removeClass('kiti-DropisDesktop');
    }
    else{
      $(selectors.itemMega).addClass('kiti-DropisDesktop').removeClass('kiti-DropisMobile');
    }
    if( window_size <= 480 || $(selectors.headerIsVisible).innerWidth() <= 480 ){
      if( $(selectors.headerIsVisible).length >0){
        setTimeout(function(){
          $(selectors.itemMega).each(function(index,element){
            var container = $(element).closest(selectors.headerIsVisible),
                container_offset = container.offset(),
                container_width = container.innerWidth();
            $(element).children(selectors.contentItemMega).css({'max-width':container_width+'px'});
            var sub_menu_width = $(element).children(selectors.contentItemMega).outerWidth(),
                item_width = $(element).outerWidth();
            $(element).children(selectors.contentItemMega).css({'left':'-'+(sub_menu_width/2 - item_width/2)+'px'});
            var container_left = container_offset.left,
                container_right = (container_left + container_width),
                item_left = $(element).offset().left,
                overflow_left = (sub_menu_width/2 > (item_left - container_left)),
                overflow_right = ((sub_menu_width/2 + item_left) > container_right);
            if( overflow_left ){
              var left = (item_left - container_left);
              $(element).children(selectors.contentItemMega).css({'left':-left+'px'});
            }
            if( overflow_right && !overflow_left ){
              var left = (item_left - container_left);
              left = left - ( container_width - sub_menu_width );
              $(element).children(selectors.contentItemMega).css({'left':-left+'px'});
            }
          })
        },100);
      }
    }
    else{
      if( $(selectors.headerIsVisibleDesktop).length >0){
        setTimeout(function(){
          $(selectors.itemMega).each(function(index,element){
            var container = $(element).closest(selectors.headerIsVisibleDesktop);
            var itemwidth_css = parseFloat(getComputedStyle($(element).find(selectors.contentItemMega)[0]).width);
            if (itemwidth_css > $(element).closest(selectors.headerIsVisible).outerWidth()) {
              itemwidth_css = $(element).closest(selectors.headerIsVisible).outerWidth();
            }
            var container_width = container.innerWidth() < itemwidth_css ? itemwidth_css : container.innerWidth();
            var container_offset = container.offset();
            $(element).children(selectors.contentItemMega).css({'max-width':container_width+'px','left':'','right':''});
            var sub_menu_width = $(element).children(selectors.contentItemMega).outerWidth();
            var item_width = $(element).outerWidth();
            $(element).children(selectors.contentItemMega).css({'left':'-'+(sub_menu_width/2 - item_width/2)+'px'});
            var container_left = container_offset.left;
            var container_right = (container_left + container_width);
            var item_left = container.innerWidth() < itemwidth_css ? $(element).find(selectors.contentItemMega).offset().left : $(element).offset().left;

            var overflow_left = (sub_menu_width/2 > (item_left - container_left));
            var overflow_right = ((sub_menu_width + item_left) > container_right);
            if( overflow_left){
              var left = (item_left - container_left); 
              $(element).children(selectors.contentItemMega).css({'left':-left+'px'});
            }
            if( overflow_right && !overflow_left ){
              var left = (item_left - container_left);
              left = left - ( container_width - sub_menu_width );
              $(element).children(selectors.contentItemMega).css({'left':-left+'px'});
            }
          })
        },100);
      }
    }
  }
  return {
    init: init
  };
})();

(function() {
  var selectors = {
    backButton: '.return-link'
  };

  var $backButton = $(selectors.backButton);

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return;
  }

  $backButton.one('click', function(evt) {
    evt.preventDefault();

    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(window.location.href);

    if (shopDomain === referrerDomain) {
      history.back();
    }

    return false;
  });

  function urlDomain(url) {
    var anchor = document.createElement('a');
    anchor.ref = url;

    return anchor.hostname;
  }
})();

/* ================ TEMPLATES ================ */

window.theme = theme || {};

theme.customerTemplates = (function() {

  function initEventListeners() {
    // Show reset password form
    $('#RecoverPassword').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    // Hide reset password form
    $('#HideRecoverPasswordLink').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
      $newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function() {
      var formId = $(this).data('form-id');
      $('#EditAddress_' + formId).toggleClass('hide');
      $(this).closest('.col-toggle').toggleClass('col-lg-6');
    });

    $('.address-delete').on('click', function() {
      var $el = $(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');

      // eslint-disable-next-line no-alert
      if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
        Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
      }
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function() {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();

/*================ SECTIONS ================*/
window.theme = window.theme || {};
theme.Cart = (function() {
  var selectors = {
    edit: '.js-edit-toggle'
  };
  var config = {
    showClass: 'cart__update--show',
    showEditClass: 'cart__edit--active',
    cartNoCookies: 'cart--no-cookies'
  };

  function Cart(container) {
    this.$container = $(container);
    this.$edit = $(selectors.edit, this.$container);

    if (!this.cookiesEnabled()) {
      this.$container.addClass(config.cartNoCookies);
    }
    this.$edit.on('click', this._onEditClick.bind(this));
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    onUnload: function() {
      this.$edit.off('click', this._onEditClick);
    },

    _onEditClick: function(evt) {
      var $evtTarget = $(evt.target);
      var $updateLine = $('.' + $evtTarget.data('target'));

      $evtTarget.toggleClass(config.showEditClass);
      $updateLine.toggleClass(config.showClass);
    },

    cookiesEnabled: function() {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled){
        document.cookie = 'testcookie';
        cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
      }
      return cookieEnabled;
    }
  });

  return Cart;
})();

window.theme = window.theme || {};
theme.Filters = (function() {
  var constants = {
    SORT_BY: 'sort_by'
  };
  var selectors = {
    filterGroup: '.kt_layerfilterGroups',
    filterGroupDesktop: '.kt_layerfilterGroupsDesktop',
    filterGroupMobile: '.kt_layerfilterGroupsMobile',
    filterLink: 'a[data-pjax-filter]',
    catShowing: '.child_collection li.current-cat'
  };
  function Filters(container) {
    var $container = (this.$container = $(container));
    this._createFilter();
    this._checkCatShowing();
  }

  Filters.prototype = _.assignIn({}, Filters.prototype, {
    _createFilter: function() {
      var filterContent = '';
      var currSearch = window.location.search;
      var currSort = $('.orderby-wapper').length ? ($('.orderby-wapper li.selected a').attr('href')).replace('?','') : undefined;
      // var currShow = $('.show-grid-list .table-view a[data-pjax-filter].active').length ? ($('.show-grid-list .table-view a[data-pjax-filter].active').attr('href')).replace('?','') : undefined;
      if(currSearch.indexOf('?sort_by=') >= 0 || currSearch.indexOf('?page=') >= 0 || currSearch.indexOf('?view=') >= 0 || currSearch.indexOf('?q=') >= 0){
        currSearch = '?'+currSearch.split('?')[1];
      }
      else{
        currSearch = '';
      }
      _.forEach(groupsFilter, function(item,idx0) {
        var filterGroupItem  = "";
        if(item.key == 'kt_rencent'){
          if (item.new_row) {filterGroupItem += '<div class="col-12 d-none d-lg-block clearfix"></div>'}
          filterGroupItem += '<div class="kt_filterGroupItem col-12 col-lg-'+item.width+' kt_filterGroupItem'+idx0+' widget widget_recent_product" style="display:none;"><h2 class="widget-title">Recent products</h2><ul class="product-categories list-unstyled">';
          // if($(window).width() < 768){
            filterGroupItem += '<li class="_"></li>';
          // }
          filterGroupItem += '</ul></div>';
        }
        else if(item.key == 'kt_banner'){
          if (item.new_row) {filterGroupItem += '<div class="col-12 d-none d-lg-block clearfix"></div>'}
          filterGroupItem += '<div class="kt_filterGroupItem col-12 col-lg-'+item.width+' kt_filterGroupItem'+idx0+' widget widget_banner"><ul class="list-unstyled"><li class="_banner text-center" style="border: none"><a href="'+item.link_url+'"><img src="'+item.img_url+'"></a></li></ul>';
          filterGroupItem += '</div>';
        }
        else if(item.key == 'kt_custom'){
          if (item.new_row) {filterGroupItem += '<div class="col-12 d-none d-lg-block clearfix"></div>'}
          filterGroupItem += '<div class="kt_filterGroupItem col-12 col-lg-'+item.width+' kt_filterGroupItem'+idx0+' widget widget_custom">'+item.content+'<ul class="list-unstyled"><li class="_"></li></ul>';
          filterGroupItem += '</div>';
        }
        else if(item.key == 'kt_categories' && $('.cat_drop.d-none').length){
          if (item.new_row) {filterGroupItem += '<div class="col-12 d-none d-lg-block clearfix"></div>'}
          filterGroupItem += '<div class="kt_filterGroupItem col-12 col-lg-'+item.width+' kt_filterGroupItem'+idx0+' widget widget_product_categories">'+$('.cat_drop .widget_product_categories').html()+'<ul class="list-unstyled m-0"><li class="_"></li></ul>';
          filterGroupItem += '</div>';
        }
        else{
          if (item.new_row) {filterGroupItem += '<div class="col-12 d-none d-lg-block clearfix"></div>'}
          filterGroupItem += '<div class="kt_filterGroupItem col-12 col-lg-'+item.width+' kt_filterGroupItem'+idx0+' blockStyle_'+item.blockStyle+' split_'+item.useSplit+'">';
          filterGroupItem += '<div class="layered_subtitle_heading"><span class="layered_subtitle">'+item.title+'<span></span></span><span class="ico"><i class="fa fa-caret-down" aria-hidden="true"></i></span></div>';
          filterGroupItem += '<ul class="kt_filterGroupItem_ul">';
          _.find(collectionTags, function(itemTag) {
            if(itemTag.indexOf(item.key+" ") === 0 && item.tags_import.length === 0){
              if(filterGroupItem.indexOf('_'+_snakeCase(itemTag.replace(item.key+" ",""))) === -1){
                filterGroupItem += '<li class="_'+_handleize(itemTag.replace(item.key+" ",""));
                if(_.indexOf(currTags_handleize, _handleize(itemTag)) >= 0){
                  filterGroupItem += ' tagSelected';
                }
                filterGroupItem += '">';
                filterGroupItem += '<a data-pjax-filter="" href="';
                if(currTags_handleize.length == 0){
                  filterGroupItem += '/collections/'+collection.Crr+'/'+_handleize(itemTag)+currSearch;
                }
                else if(_.indexOf(currTags_handleize, _handleize(itemTag)) >= 0){
                  filterGroupItem += '/collections/'+collection.Crr+'/';
                  _.forEach(currTags_handleize, function(itemCurrentTags) {
                    if(_handleize(itemTag) !== itemCurrentTags){
                      filterGroupItem += itemCurrentTags+'+';
                    }
                  })
                  filterGroupItem += currSearch;
                }else{
                  filterGroupItem += '/collections/'+collection.Crr+'/';
                  _.forEach(currTags_handleize, function(itemCurrentTags) {
                    if(_handleize(itemTag) !== itemCurrentTags){
                      filterGroupItem += itemCurrentTags+'+'
                    }
                  })
                  filterGroupItem += _handleize(itemTag)+currSearch;
                }
                filterGroupItem += '" title="'+itemTag+'">';
                if(colorGroupFilter.indexOf(item.key) !== -1){
                  filterGroupItem += '<span class="color_pick swatch" data-color="'+_handleize(itemTag.replace(item.key+" ",""))+'"></span>';
                }
                if(item.blockStyle === '6'){
                  _.forEach(brands_icon, function(itemBrandIcon) {
                    if(itemBrandIcon.indexOf(_snakeCase(itemTag.replace(item.key+" ",""))) !== -1 || _snakeCase(itemBrandIcon).indexOf(_snakeCase(itemTag.replace(item.key+" ",""))) !== -1){
                      filterGroupItem += '<span class="brand_icon"><img src="';
                      filterGroupItem += itemBrandIcon;
                      filterGroupItem += '"></span>';
                    }
                  });
                }
                filterGroupItem += '<span class="titleFilterItem rtl_fix" data-ogr-title="'+itemTag.replace(item.key+" ","")+'">'+itemTag.replace(item.key+" ","")+'</span>';
                filterGroupItem += '</a>';
                filterGroupItem += '</li>';
              }
            }
            else if(item.tags_import.length > 0){
              _.forEach(item.tags_import, function(item_,idx0) {
                if(_snakeCase(itemTag) === _snakeCase(item_) && filterGroupItem.indexOf('_'+_snakeCase(itemTag.replace(item.key+" ",""))) === -1){
                  filterGroupItem += '<li class="_'+_handleize(itemTag);
                  if(_.indexOf(currTags_handleize, _handleize(itemTag)) >= 0){
                    filterGroupItem += ' tagSelected';
                  }
                  filterGroupItem += '">';
                  filterGroupItem += '<a data-pjax-filter="" href="';
                  if(currTags_handleize.length == 0){
                    filterGroupItem += '/collections/'+collection.Crr+'/'+_handleize(itemTag)+currSearch;
                  }
                  else if(_.indexOf(currTags_handleize, _handleize(itemTag)) >= 0){
                    filterGroupItem += '/collections/'+collection.Crr+'/';
                    _.forEach(currTags_handleize, function(itemCurrentTags) {
                      if(_handleize(itemTag) !== itemCurrentTags){
                        filterGroupItem += itemCurrentTags+'+'
                      }
                    })
                    filterGroupItem += currSearch;
                  }
                  else{
                    filterGroupItem += '/collections/'+collection.Crr+'/';
                    _.forEach(currTags_handleize, function(itemCurrentTags) {
                      if(itemTag !== itemCurrentTags){
                        filterGroupItem += itemCurrentTags+'+'
                      }
                    })
                    filterGroupItem += _handleize(itemTag)+currSearch;
                  }
                  filterGroupItem += '" title="'+itemTag+'">';                
                  if(colorGroupFilter.indexOf(item.key) !== -1){
                    filterGroupItem += '<span class="color_pick swatch" data-color="'+_handleize(itemTag)+'"></span>';
                  }
                  if(item.blockStyle === '6'){
                    _.forEach(brands_icon, function(itemBrandIcon) {
                      if(itemBrandIcon.indexOf(_snakeCase(itemTag.replace(item.key+" ",""))) !== -1 || _snakeCase(itemBrandIcon).indexOf(_snakeCase(itemTag.replace(item.key+" ",""))) !== -1){
                        filterGroupItem += '<span class="brand_icon"><img src="';
                        filterGroupItem += itemBrandIcon;
                        filterGroupItem += '"></span>';
                      }
                    });
                  }
                  filterGroupItem += '<span class="titleFilterItem">'+itemTag+'</span>';
                  filterGroupItem += '</a>';
                  filterGroupItem += '</li>';
                }
              });
            }
          })
          filterGroupItem += '</ul>';
          filterGroupItem += '</div>';
        }
        if(filterGroupItem.indexOf('<li class="_') !== -1){
          filterContent += filterGroupItem;
        }
      })
      $(selectors.filterGroupDesktop).addClass('colFilter-'+$(filterContent).length);
      if($(window).width() >= 992){
        $(selectors.filterGroupDesktop).html('<div class="d-flex flex-wrap">'+filterContent+'</div>');
      }
      else{
        $(selectors.filterGroupMobile).html(filterContent);
        // if($(selectors.filterGroupMobile).find('.kt_filterGroupItem0').length > 0){
        //   $('.kt_filterGroupItem0').addClass('show');
        // }
        if($('.kt_layerfilterGroups .kt_filterGroupItem').last().hasClass('blockStyle_3') || $('.kt_layerfilterGroups .kt_filterGroupItem').last().hasClass('blockStyle_6') || $('.kt_layerfilterGroups .kt_filterGroupItem').last().hasClass('blockStyle_7')){
          $('.kt_layerfilterGroups .kt_filterGroupItem').last().addClass('showAny')
        }
        if($('.kt_layerfilterGroups .kt_filterGroupItem').first().hasClass('widget_product_categories')){
          $('.kt_layerfilterGroups .kt_filterGroupItem').first().addClass('showAny')
        }
      }
      recentlyViewedListSidebar();
      if (typeof currSort !== undefined){
        _.forEach($('.orderby-wapper a'), function(itemOrderby,idx0) {
          var newSort = ($(itemOrderby).attr('href')).replace('?','');
          if(currSearch !== '' && currSearch.indexOf('sort_by=') === -1 && currSearch.indexOf(($(itemOrderby).attr('href')).replace('?','')) === -1){
            $(itemOrderby).attr('href',currSearch+($(itemOrderby).attr('href')).replace('?','&'))
          }
          else if(currSearch !== '' && currSearch.indexOf('sort_by=') !== -1 && currSearch.indexOf(($(itemOrderby).attr('href')).replace('?','')) === -1){
            $(itemOrderby).attr('href',currSearch.replace(currSort,newSort));
          }else if(currSort == newSort){
            $(itemOrderby).attr('href',currSearch);
          }
        });
      }

      // if (typeof currShow !== undefined){
      //   _.forEach($('.show-grid-list .table-view a'), function(itemShow,idx0) {
      //     var newShow = ($(itemShow).attr('href')).replace('?','');
      //     if(currSearch !== '' && currSearch.indexOf('view=') === -1 && currSearch.indexOf(($(itemShow).attr('href')).replace('?','')) === -1){
      //       $(itemShow).attr('href',currSearch+($(itemShow).attr('href')).replace('?','&'));
      //     }
      //     else if(currSearch !== '' && currSearch.indexOf('view=') !== -1 && currSearch.indexOf(($(itemShow).attr('href')).replace('?','')) === -1){
      //       $(itemShow).attr('href',currSearch.replace(currShow,newShow));
      //     }else if(currShow == newShow){
      //       $(itemShow).attr('href',currSearch);
      //     }
      //   });
      // }
      $('#filterApply').html($('.result-count').html());
      $('#filterSelected').html($('.filter-container__selected-filter').html());
      if($(selectors.filterGroup).find('.tagSelected').length > 0){
        $('#filterClear').show();
      }
      else{
        $('#filterClear').hide();
      }
    },
    _checkCatShowing: function() {
      if($(selectors.catShowing).length > 0){
        $(selectors.catShowing).parents('li.level-1').addClass('showAny');
      }
    },
    onUnload: function() {}
  });

  return Filters;
})();

theme.clickOnScrollButton = (function(){
  var viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
  var element = $('.kt_layerFilterJS a[data-action="infinity"]').not('.loading')[0];
  if(element !== undefined && getComputedStyle($('.kt_layerFilterJS').find('.loadMore')[0]).display !== "none" && element.getBoundingClientRect().top <= viewportHeight + 100){
    disableScroll();    
    $('.kt_layerFilterJS').find('a[data-action="infinity"]').trigger('click');
  }
});

theme.FiltersPjax = (function(){
  var loadmore = false;
  var scrollTop = null;
  $(document).on('click', 'a[data-pjax-filter]', function(event) {
    if ($.support.pjax) {
      if($(this).attr('data-action') === 'loadmore' || $(this).attr('data-action') === 'infinity' ){
        $.pjax.click(event, {
          container: '.product-listing-loadmore',
          fragment: '.product-listing',
          timeout: 4000,
          scrollTo: false,
          replace: false,
          push: false
        });
        $(this).addClass('loading').text($(this).attr('data-text-loading'));
        if($(this).attr('data-action') === 'infinity'){
          $('.loadingFilter .card.d-none').addClass('bottom').removeClass('d-none');
        }
        loadmore = true;
      }
      else{
        $('.loadingFilter .d-none').removeClass('d-none');
        $.pjax.click(event, {
          container: '.kt_layerFilterJS',
          fragment: '.kt_layerFilterJS',
          timeout: 4000,
          scrollTo: false
        });
      }
      if($(this).attr('data-scroll-top') !== undefined){
        scrollTop = true;
        $('div[data-section-id="kt_collection_banner"]').find('img').css('opacity',0.5)
      }
    }
  });

  $(document).on('click','a[data-ktpjax]:not([data-col])', function(){
    $('.loadingFilter .d-none').removeClass('d-none');
    var val = $(this).attr('data-href');
    $('.ktjax').attr('href',theme.Images.removeProtocol(window.location.href));
    $.ajax({
      type: "POST",
      url: '/cart.js',
      data: {"attributes[theme_coll_layout]": val},
      dataType: 'json',
      success: function(d){
        if ($.support.pjax) {
          $('.ktjax').trigger('click');
        } else {
          window.location.reload();
        }
      }
    });
  });

  $(document).on('click','a[data-ktpjax][data-col]', function(){
    $('.show-grid-list').css('pointer-events', 'none');
    var val = $(this).attr('data-href');
    $.ajax({
      type: "POST",
      url: '/cart.js',
      data: {"attributes[theme_coll_layout]": val},
      dataType: 'json',
      success: function() {
        $('.product-listing .lazyloaded').addClass('lazyload');
        $('.show-grid-list').css('pointer-events', '');
      }
    });
    $('a[data-ktpjax][data-col]').removeClass('active');
    $(this).addClass('active');
    $('.show-grid-list .layered_subtitle').html($(this).html());
    $('.show-pds').each(function(){
      $(this).attr('data-href',val.split('_')[0]+$(this).attr('data-pds'))
    });
    var col_crr = $('.product-listing').attr('data-grid'), fix_col_crr = $(this).attr('data-fix-grid');
    var col = $(this).attr('data-col'), fix_col = $(this).attr('data-fix-col');
    $('.product-listing').attr({'class': $('.product-listing').attr('class').replace(fix_col_crr,fix_col), 'data-fix-grid': col_crr, 'data-grid': col});
    $('.product-listing li.grid-item').attr('class', $('.product-listing li.grid-item').attr('class').replace(col_crr,col));    
    theme.checkProductGrid_Width();
    if($('.product-listing[data-section-type="masory-section"]').length > 0){
      var $grid = $('#Masory-collection-template.ly__ms_items').isotope({
        itemSelector: '.grid-item',
        masonry: {
          horizontalOrder: true,
          percentPosition: true
        },
        transitionDuration: '.8s'
      });
    }    
  });

  $(document).on('pjax:success', function() {
    if(loadmore){
      $('.product-listing').find('.product-listing-loadmore').first().addClass('removeElement');
      $('.product-listing').append($('.product-listing').find('.product-listing-loadmore').first().html());
      $('.product-listing').find('.product-listing-loadmore.removeElement').first().remove();
      $('.CountEnd').text($('.product-listing').find('.grid-item').length);
      var CountEnd = $('.CountEnd').text(), AllCount = $('.AllCount').text(), $aMore = $('.pagination_ [data-action]');
      if(+CountEnd < +AllCount){
        var curPage = $aMore.attr('data-page').replace('page_','')
        $aMore.attr('href',$aMore.attr('href').replace('page='+curPage,'page='+(+curPage+1))).attr('data-page','page_'+(+curPage+1));
      }
      else{
        $('.pagination_ .loadMore').hide();
      }
      $aMore.removeClass('loading').text($aMore.attr('data-text-button'));
      $('#filterApply').html($('.result-count').html());      
      if($('.loadingFilter .card.bottom').length > 0){$('.loadingFilter .card.bottom').addClass('d-none').removeClass('bottom')};
      enableScroll();
    }
    else if(scrollTop == true){
      $('html').animate({scrollTop:0}, 'slow');
      scrollTop = false;
    }
    else{
      var offsetTop = $('.header.ontop').length !== 0 ? $('#PageContainer').offset().top - ($('.header.ontop').height()) * 2 : $('#PageContainer').offset().top - 100;
      $('html').animate({scrollTop:offsetTop}, 'slow');
    }
    if($('.product-listing[data-section-type="masory-section"]').length > 0){
      var count = 0, length = $('.product-listing .grid-item:not([style])').length;
      $.each($('.product-listing .grid-item:not([style])'), function(index, val) {
        var $this = $(this).find('img').first();
        var imgLarge = new Image();
        imgLarge.src = $this.attr('src');
        imgLarge.onload = function () {
          var $this_ = $this.closest('.grid-item');
          if ($this_.attr('style') == undefined){
            $('.product-listing').isotope()
            .append($this_)
            .isotope( 'appended', $this_);
            count++
          }
          if (count == length){
            $('.product-listing').isotope('layout');
          }
        }
      });
    }
    else if($('.ly__lis').length > 0 || $('.ly__leftlis').length > 0 || $('.ly__leftlis').length > 0){
      var grid_item = '.grid-item.list';
      $('li'+grid_item+' .listThumbScroll').each(function(){
        var $this = $(this);
        var images = $(this).parents('li'+grid_item).find('.product-thumb .front-image img');
        images.on('load', function(){
          $this.css('height',$(this).height()+'px');
          $this.find('.ab').removeClass('ab');
          $this.mThumbnailScroller({
            axis:"y", //change to "y" for vertical scroller
            type:"hover-precise"
          });
        });
      });
    }
    loadmore = false;
    theme.checkProductGrid_Width();
  })
  $(document).on('pjax:complete', function() {
    var sections = new theme.Sections();
    sections.register('collection-template', theme.Filters);
    sections.register('banner-page-section',theme.BannerByPage);
    sections.register('masory-section', theme.ProductsMasorySection);
    theme.DropdownReposive.init('.kiti--DropWindow','.kiti--DropItem','.kiti--DropInner');
    KT.fixGridSwatch();
    if($('.loadingFilter .card').length > 0){$('.loadingFilter .card').addClass('d-none').removeClass('bottom')};
  });
});

theme.filtersHeader = (function(container) {
  var selectors = {
    filterGroup: '.kt_layerfilterGroups'
  };
  var $container = (this.$container = $(container));
  function onHover() {
    $(document).on('mouseenter touchstart','[data-block="filter"]',function(){
      var $this = $(this);
      var $url = $(this).children('a').attr('href') + '?view=shopbyAjax';
      if ($this.hasClass('loaded') === false) {
        $this.addClass('loaded');
        $.get($url, function(data) {
          var html = data
                      .replace('id="shopify-section-collection-filter"','id="shopify-section-header-filter"')
                      .replace('collection.Crr = ','var collection_header = {Crr:null}; collection_header.Crr = ')
                      .replace('page.Han = ','var page_header = {Han:null};  page_header.Han = ')
                      .replace('groupsFilter = ','groupsFilter_header = ')
                      .replace('brands_icon = ','brands_icon_header = ')
                      .replace('colorGroupFilter = ','colorGroupFilter_header = ')
                      .replace('collectionTags = ','collectionTags_header = ')
          $container.find(selectors.filterGroup).append(html);
          theme.filtersHeader().createFilter($this)
        })
      }
    })
  }
  function createFilter(el) {
    var filterContent = '';
    var currSearch = window.location.search;
    if(currSearch.indexOf('?sort_by=') >= 0 || currSearch.indexOf('?page=') >= 0 || currSearch.indexOf('?view=') >= 0 || currSearch.indexOf('?q=') >= 0){
      currSearch = '?'+currSearch.split('?')[1];
    }
    else{
      currSearch = '';
    }
    _.forEach(groupsFilter_header, function(item,idx0) {
      var filterGroupItem  = "";
      if(item.key == 'kt_banner'){
        if (item.new_row) {filterGroupItem += '<div class="col-12 d-none d-lg-block clearfix"></div>'}
        filterGroupItem += '<div class="kt_filterGroupItem col-12 col-lg-'+item.width+' kt_filterGroupItem'+idx0+' widget widget_banner"><ul class="list-unstyled"><li class="_banner text-center" style="border: none"><a href="'+item.link_url+'"><img src="'+item.img_url+'"></a></li></ul>';
        filterGroupItem += '</div>';
      }
      else if(item.key == 'kt_custom'){
        if (item.new_row) {filterGroupItem += '<div class="col-12 d-none d-lg-block clearfix"></div>'}
        filterGroupItem += '<div class="kt_filterGroupItem col-12 col-lg-'+item.width+' kt_filterGroupItem'+idx0+' widget widget_custom">'+item.content+'<ul class="list-unstyled"><li class="_"></li></ul>';
        filterGroupItem += '</div>';
      }
      else if(item.key == 'kt_categories' && el.find('.cat_drop_header.d-none').length){
        if (item.new_row) {filterGroupItem += '<div class="col-12 d-none d-lg-block clearfix"></div>'}
        filterGroupItem += '<div class="kt_filterGroupItem col-12 col-lg-'+item.width+' kt_filterGroupItem'+idx0+' widget widget_product_categories">'+el.find('.cat_drop_header .widget_product_categories').html()+'<ul class="list-unstyled m-0 d-none"><li class="_"></li></ul>';
        filterGroupItem += '</div>';
      }
      else{
        if (item.new_row) {filterGroupItem += '<div class="col-12 d-none d-lg-block clearfix"></div>'}
        filterGroupItem += '<div class="kt_filterGroupItem col-12 col-lg-'+item.width+' kt_filterGroupItem'+idx0+' blockStyle_'+item.blockStyle+' split_'+item.useSplit+'">';
        filterGroupItem += '<div class="layered_subtitle_heading"><span class="layered_subtitle">'+item.title+'<span></span></span><span class="ico"><i class="fa fa-caret-down" aria-hidden="true"></i></span></div>';
        filterGroupItem += '<ul class="kt_filterGroupItem_ul">';
        _.find(collectionTags_header, function(itemTag) {
          if(itemTag.indexOf(item.key+" ") === 0 && item.tags_import.length === 0){
            if(filterGroupItem.indexOf('_'+_snakeCase(itemTag.replace(item.key+" ",""))) === -1){
              filterGroupItem += '<li class="_'+_handleize(itemTag.replace(item.key+" ",""));
              if(_.indexOf(currTags_handleize, _handleize(itemTag)) >= 0){
                filterGroupItem += ' tagSelected';
              }
              filterGroupItem += '">';
              filterGroupItem += '<a data-pjax-filter="" href="';
              if(currTags_handleize.length == 0){
                filterGroupItem += '/collections/'+collection_header.Crr+'/'+_handleize(itemTag)+currSearch;
              }
              else if(_.indexOf(currTags_handleize, _handleize(itemTag)) >= 0){
                filterGroupItem += '/collections/'+collection_header.Crr+'/';
                _.forEach(currTags_handleize, function(itemCurrentTags) {
                  if(_handleize(itemTag) !== itemCurrentTags){
                    filterGroupItem += itemCurrentTags+'+';
                  }
                })
                filterGroupItem += currSearch;
              }else{
                filterGroupItem += '/collections/'+collection_header.Crr+'/';
                _.forEach(currTags_handleize, function(itemCurrentTags) {
                  if(_handleize(itemTag) !== itemCurrentTags){
                    filterGroupItem += itemCurrentTags+'+'
                  }
                })
                filterGroupItem += _handleize(itemTag)+currSearch;
              }
              filterGroupItem += '" title="'+itemTag+'">';
              if(colorGroupFilter_header.indexOf(item.key) !== -1){
                filterGroupItem += '<span class="color_pick swatch" data-color="'+_handleize(itemTag.replace(item.key+" ",""))+'"></span>';
              }
              if(item.blockStyle === '6'){
                _.forEach(brands_icon_header, function(itemBrandIcon) {
                  if(itemBrandIcon.indexOf(_snakeCase(itemTag.replace(item.key+" ",""))) !== -1 || _snakeCase(itemBrandIcon).indexOf(_snakeCase(itemTag.replace(item.key+" ",""))) !== -1){
                    filterGroupItem += '<span class="brand_icon"><img src="';
                    filterGroupItem += itemBrandIcon;
                    filterGroupItem += '"></span>';
                  }
                });
              }
              filterGroupItem += '<span class="titleFilterItem rtl_fix" data-ogr-title="'+itemTag.replace(item.key+" ","")+'">'+itemTag.replace(item.key+" ","")+'</span>';
              filterGroupItem += '</a>';
              filterGroupItem += '</li>';
            }
          }
          else if(item.tags_import.length > 0){
            _.forEach(item.tags_import, function(item_,idx0) {
              if(_snakeCase(itemTag) === _snakeCase(item_) && filterGroupItem.indexOf('_'+_snakeCase(itemTag.replace(item.key+" ",""))) === -1){
                filterGroupItem += '<li class="_'+_handleize(itemTag);
                if(_.indexOf(currTags_handleize, _handleize(itemTag)) >= 0){
                  filterGroupItem += ' tagSelected';
                }
                filterGroupItem += '">';
                filterGroupItem += '<a data-pjax-filter="" href="';
                if(currTags_handleize.length == 0){
                  filterGroupItem += '/collections/'+collection_header.Crr+'/'+_handleize(itemTag)+currSearch;
                }
                else if(_.indexOf(currTags_handleize, _handleize(itemTag)) >= 0){
                  filterGroupItem += '/collections/'+collection_header.Crr+'/';
                  _.forEach(currTags_handleize, function(itemCurrentTags) {
                    if(_handleize(itemTag) !== itemCurrentTags){
                      filterGroupItem += itemCurrentTags+'+'
                    }
                  })
                  filterGroupItem += currSearch;
                }
                else{
                  filterGroupItem += '/collections/'+collection_header.Crr+'/';
                  _.forEach(currTags_handleize, function(itemCurrentTags) {
                    if(itemTag !== itemCurrentTags){
                      filterGroupItem += itemCurrentTags+'+'
                    }
                  })
                  filterGroupItem += _handleize(itemTag)+currSearch;
                }
                filterGroupItem += '" title="'+itemTag+'">';                
                if(colorGroupFilter_header.indexOf(item.key) !== -1){
                  filterGroupItem += '<span class="color_pick swatch" data-color="'+_handleize(itemTag)+'"></span>';
                }
                if(item.blockStyle === '6'){
                  _.forEach(brands_icon_header, function(itemBrandIcon) {
                    if(itemBrandIcon.indexOf(_snakeCase(itemTag.replace(item.key+" ",""))) !== -1 || _snakeCase(itemBrandIcon).indexOf(_snakeCase(itemTag.replace(item.key+" ",""))) !== -1){
                      filterGroupItem += '<span class="brand_icon"><img src="';
                      filterGroupItem += itemBrandIcon;
                      filterGroupItem += '"></span>';
                    }
                  });
                }
                filterGroupItem += '<span class="titleFilterItem">'+itemTag+'</span>';
                filterGroupItem += '</a>';
                filterGroupItem += '</li>';
              }
            });
          }
        })
        filterGroupItem += '</ul>';
        filterGroupItem += '</div>';
      }
      if(filterGroupItem.indexOf('<li class="_') !== -1){
        filterContent += filterGroupItem;
      }
    })
    el.find(selectors.filterGroup).addClass('colFilter-'+$(filterContent).length).html('<div class="row">'+filterContent+'</div>');
    el.find('.cat_drop_header.d-none').remove();
    // el.find('#shopify-section-header-filter').remove();
    KT.fixGridSwatch();
  }
  return {
    onHover: onHover,
    createFilter: createFilter
  };
});

window.theme = window.theme || {};
theme.HeaderSection = (function() {

  function Header(container) {
    theme.MenuReposive.init();
    theme.ResizeNavMega.init();
    theme.filtersHeader(container).onHover();
    if ($(container).data('sticky') === true) {theme.StickyMenu.init();}
    if ($(container).find('.categorys-menu.overx').length > 0 || $(container).find('.categorys-menu.overy').length > 0) {theme.scrollbarCategory(container);}
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function() {
      theme.MenuReposive.unload();
    },
    onSelect: function(evt) {
      theme.MenuReposive.js_right_follow('#header');
    },
    onBlockSelect: function(evt) {
      theme.MenuReposive.js_right_follow('#header');
    }
  });

  return Header;
})();

theme.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];
  var key = theme.mapKey ? theme.mapKey : '';

  function Map(container) {
    this.$container = $(container);

    if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript('https://maps.googleapis.com/maps/api/js?key=' + key)
            .then(function() {
              apiStatus = 'loaded';
              initAllMaps();
            });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({address: address}, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function() {
      var $map = this.$container.find('.map-section__container');

      return geolocate($map)
        .then(function(results) {
          var mapOptions = {
            zoom: config.zoom,
            center: results[0].geometry.location,
            disableDefaultUI: true
          };

          var map = this.map = new google.maps.Map($map[0], mapOptions);
          var center = this.center = map.getCenter();

          //eslint-disable-next-line no-unused-vars
          var marker = new google.maps.Marker({
            map: map,
            position: map.getCenter()
          });

          google.maps.event.addDomListener(window, 'resize', $.debounce(250, function() {
            google.maps.event.trigger(map, 'resize');
            map.setCenter(center);
          }));
        }.bind(this))
        .fail(function() {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = theme.strings.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = theme.strings.addressQueryLimit;
              break;
            default:
              errorMessage = theme.strings.addressError;
              break;
          }

          $map
            .parent()
            .addClass('page-width map-section--load-error')
            .html('<div class="errors text-center">' + errorMessage + '</div>');
        });
    },

    onUnload: function() {
      google.maps.event.clearListeners(this.map, 'resize');
    }
  });

  return Map;
})();

// Global function called by Google on auth errors.
// Show an auto error message on all map instances.
// eslint-disable-next-line camelcase, no-unused-vars
function gm_authFailure() {
  $('.map-section').addClass('map-section--load-error');
  $('.map-section__container').remove();
  $('.map-section__link').remove();
  $('.map-section__overlay').after('<div class="errors text-center">' + theme.strings.authError + '</div>');
}

/* eslint-disable no-new */
theme.Product = (function() {
  function Product(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var productsectionId = $container.attr('data-product-id');
    theme.ktCountdown(container);
    theme.dateFromTo(container);
    theme.realTimeVisitor(container);

    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 749px)',
      bpSmall: false,
      enableHistoryState: $container.data('enable-history-state') || false,
      imageSize: "530x@2x",
      imageZoomSize: null,
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      zoomEnabled: false
    };

    this.selectors = {
      template: '#ProductSection-' + sectionId,
      addToCart: '#AddToCart-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,
      addToCartMore: '#AddToCartMore-'+ sectionId,
      comparePrice: '#ComparePrice-' + sectionId,
      originalPrice: '#ProductPrice-' + sectionId,
      variesPrice: '#ProductVaries-' + sectionId,
      SKU: '.variant-sku',
      originalPriceWrapper: '.product-price__price-' + sectionId,
      originalSelectorId: '#ProductSelect-' + sectionId,
      variantSelectorId: '#ProductVariantSelect-' + sectionId,
      productFeaturedImage: '.product-single__photos-' + sectionId + ' .product-single__photo.active-photo',
      productThumbSlick: '.productThumbSlide--' + sectionId,
      productPrices: '.product-single__price-' + sectionId,
      productPhotoImages: '.product-single__photo--' + sectionId,
      productPhotos: '.product-single__photos-' + sectionId,
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbs: '.product-single__thumbnails-' + sectionId,
      saleClasses: '#ProductSection-' + sectionId + 'product-price__sale product-price__sale--single',
      saleLabel: '.product-price__sale-label-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      dataSettings: '.datasettings--' + sectionId,
      dataJs: '.datajs--' + sectionId
    }

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(document.getElementById('ProductJson-' + sectionId).innerHTML);
    this.dataSettings = $(this.selectors.dataSettings).data();
    this.dataJs = $(this.selectors.dataJs).data();
    this._initBreakpoints();
    this._stringOverrides();
    this._initVariants();
    this._initImageSwitch();
    this._create360();
    this._checkVariantVideo();
    if(this.dataSettings.layoutSection == 3){
      this._initStickySummary();
      this._initPhotoSwipeFromDOM();
    }
    this._initAddMore();
    if(this.dataSettings.useMaxheight){
      this._onReSize();
    }
    this._stickyAddCart();
    // Pre-loading product images to avoid a lag when a thumbnail is clicked, or
    // when a variant is selected that has a variant image
    if(this.settings.sectionId !== _.toString(this.productSingleObject.id)){
      theme.Images.preload(this.productSingleObject.images[0], this.settings.imageSize);
      theme.Images.preload(this.productSingleObject.images[0], '110x110@2x');
    }
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    _stringOverrides: function() {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    _initBreakpoints: function() {
      var self = this;
      KT.loadScript('slick-slide', function(e,l){
        if (l == 'ok') {
          // initialize thumbnail slider on mobile if more than three thumbnails
          if ($(self.selectors.productThumbImages).length >= 1) {
            $(self.selectors.template).addClass('loading_thumb');
            self._initThumbnailSlider();
          }
          // initialize photo slider
          if ($(self.selectors.productPhotoImages).length >= 1) {
            $(self.selectors.template).addClass('loading_photo');
            self._initPhotoSlider();
          }
        }
      })
    },

    _initVariants: function() {
      var self = this;
      var options = {
        $container: this.$container,
        enableHistoryState: this.$container.data('enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };
      if(options.product.variants[0].requires_shipping == false){$(this.selectors.template+' .freeShipping').removeClass('hidden')}
      this.variants = new slate.Variants(options);
      this.$container.on('variantChange' + this.settings.namespace, this._updateAddToCart.bind(this));
      if(this.dataSettings.layoutSection !== 3){
        this.$container.on('variantImageChange' + this.settings.namespace, this._updateImages.bind(this));
      }
      this.$container.on('variantPriceChange' + this.settings.namespace, this._updatePrice.bind(this));
      this.$container.on('variantSKUChange' + this.settings.namespace, this._updateSKU.bind(this));
      if(options.product.options.length >= 1 && options.product.options[0] !== "Title"){
        var option = this.variants.currentVariant.option1, check_option = 0;
        var optitonSelector1 = 'SingleOptionSelector-0--'+self.settings.sectionId;
        var optitonSelector2 = 'SingleOptionSelector-1--'+self.settings.sectionId;
        var optitonSelector3 = 'SingleOptionSelector-2--'+self.settings.sectionId;
        _.forEach(self.productSingleObject.variants, function(value) {
          $.each($('#'+optitonSelector1+' option'), function(index,el) {
            if(value.option1 !== option){
              check_option = 0;option = value.option1;
            }
            if(check_option == 0 && $(this).val() == value.option1){
              var firstVariant = _handleize(value.option1);
              if(value.option2){firstVariant = firstVariant +' / '+ _handleize(value.option2)}
              if(value.option3){firstVariant = firstVariant +' / '+ _handleize(value.option3)}
              $(this).attr({
                'data-first-variant': firstVariant,
                'data-first-variant-title': value.title
              });
              if(value.featured_image){
                $(this).attr('data-featured-image', value.featured_image.src);
              }
              check_option++;
            }
          });
        });
        $.each($(self.selectors.template+' .fake_select'), function(index, el) {
          // console.log(index,$(this).data('name-option'))
          var settings_op = _.find(theme.function.productOptionStyle, { 'name': $(this).data('name-option')});
          // console.log(settings_op)
          if(settings_op !== undefined){
            if (settings_op.style === "combobox") {

            }
            else if(settings_op.style === "combobox with_out_variant_image") {
              $(this).addClass(settings_op.style);
              var build_vrs_img = '';
              $.each($(this).find('li'), function(idx, el) {
                var featuredImage = $(this).closest('.selector-wrapper.js').find('.single-option-selector option[value="'+$(this).attr('data-value')+'"]').attr('data-featured-image');
                if (featuredImage !== undefined) {           
                  var fileExt = _.last(featuredImage.split('.')), featuredImage = featuredImage.replace('.'+fileExt, '_150x150_crop_center.'+fileExt);
                  build_vrs_img += $(this)[0].outerHTML.replace($(this)[0].innerHTML,'<img src="'+featuredImage+'"/>');
                }
              });
              if (build_vrs_img !== ''){
                $(this).closest('.selector-wrapper.js').addClass('sw_large');
                $(this).closest('.selector-wrapper.js').append('<ul class="fake_select variant_image list-inline">'+build_vrs_img+'</ul>')
              }
            }
            else if (settings_op.style === "not_select radio_button" || settings_op.style === "not_select radio_button inline") {
              $(this).removeClass('combobox').addClass(settings_op.style);
              $(this).find("label[data-change-label]").addClass('not_combobox');
              $(this).closest('.selector-wrapper.js').addClass('sw_large');
              $.each($(this).find('li'), function(idx, el) {
                var swatch  ='<span class="check_btn"></span>';
                $(this).removeClass('sw').addClass('check_btn_style').prepend(swatch);
              });
            }
            else{
              $(this).removeClass('combobox').addClass(settings_op.style);
              $(this).closest('.selector-wrapper.js').addClass('sw_large');
              $(this).find("label[data-change-label]").addClass('not_combobox');
              if(settings_op.color_watched){
                // $(this).addClass('small_swatch');
                $.each($(this).find('li'), function(idx, el) {
                  var featuredImage = $(this).closest('.selector-wrapper.js').find('.single-option-selector option[value="'+$(this).attr('data-value')+'"]').attr('data-featured-image');
                  if (featuredImage !== undefined) {           
                    var fileExt = _.last(featuredImage.split('.')), featuredImage = featuredImage.replace('.'+fileExt, '_100x100_crop_center.'+fileExt);
                  }
                  var swatchStyle = self.dataSettings.swatchStyle == 'image_variant' ? ' bg-contain' : '';
                  var swatch = '<span class="swatch'+swatchStyle+'" data-color="'+_handleize($(this).data('value'))+'"';
                  swatch += featuredImage !== undefined && self.dataSettings.swatchStyle !== 'color' ? ' style="background-image:url('+featuredImage+')"' : '';
                  swatch += '></span>';
                  $(this).removeClass('sw').addClass('color_sw').prepend(swatch);
                });
              }
            }
          }
        });
        this._changeVariants(this.variants.currentVariant);
      }
    },

    _initAddMore: function() {
      var self = this;
      $(document).on('click', self.selectors.addToCartMore, function(e) {
        $('#addMoreModal select.single-option-selector').on('change', function() {
          var select = '';
          for (var i = 0; i < $('#addMoreModal select.single-option-selector').length; i++) {
            var val = $('#addMoreModal #SingleOptionSelector-'+i+'--addmore-template').val();
            if (val !== 'all') {
              select += '.'+val;
            }
            if (i == $('#addMoreModal select.single-option-selector').length - 1) {
              select !== '' ? select+=', .selected' : select;
              $('#addMoreModal .full-list-variants').isotope({ filter: select })
            }
          }
        });
        $('#addMoreModal').modal();
        setTimeout(function(){
          $('#addMoreModal .full-list-variants').isotope({
            itemSelector: '.item-variant',
            layoutMode: 'fitRows'
          })
        }, 600)
        $('#kt_addmore input[type="checkbox"],#kt_addmore input[type="number"]').on('change', function() {
          var price = 0;
          $.each($('#kt_addmore input[type="checkbox"]'), function(index, val) {
            if ($(this).is(':checked')) {
              var vrId = $(this).attr('data-vr-id');
              price = price + (parseInt($('.variant--'+vrId+' .price').attr('data-price-default')) * parseInt($('[name="quantity__'+vrId+'"]').val()));
            }
          });
          var line_total = parseInt($('#addMoreModal').find('[data-total]').data('total'));
          var progress_bar = $('#addMoreModal').find('.progress-bar');
          $('#addMoreModal').find('.subtotal .subtotal-number').html(theme.Currency.formatMoney(price, theme.moneyFormat));
          if (line_total > price){
            $('#addMoreModal').find('.content_threshold strong.spend_price').html(theme.Currency.formatMoney(line_total - price, theme.moneyFormat))
            progress_bar.attr('aria-valuenow', line_total - price).css('width',price / line_total * 100 + '%').text(Math.round(price / line_total * 100) + '%');
            $('#addMoreModal').find('.content_threshold:not(.threshold_congrats)').removeClass('hidden');
            $('#addMoreModal').find('.threshold_congrats').addClass('hidden');
          }else{
            progress_bar.attr('aria-valuenow', line_total).css('width','100%').text('100%');
            $('#addMoreModal').find('.content_threshold:not(.threshold_congrats)').addClass('hidden');
            $('#addMoreModal').find('.threshold_congrats').removeClass('hidden');
          }
          if(theme.function.multiCurrency == true && cookieCurrency !== null && cookieCurrency !== shopCurrency){
            Currency.convertAll(shopCurrency,cookieCurrency,'#addMoreModal span.money');
          }
        });
        $('#addMoreModal').find('#checkbox--'+self.variants.currentVariant.id).prop("checked" ,true).trigger('change');
        $('#addMoreModal').find('.variant--'+self.variants.currentVariant.id).addClass('selected');
      });
    },

    _changeVariants: function(currentVariant) {
      var self = this;
      var options2 = new Array, options3 = new Array;
      var option = currentVariant.option1, check_option = 0;
      var optitonSelector1 = 'SingleOptionSelector-0--'+self.settings.sectionId;
      var optitonSelector2 = 'SingleOptionSelector-1--'+self.settings.sectionId;
      var optitonSelector3 = 'SingleOptionSelector-2--'+self.settings.sectionId;
      $.each($('.single-option-selector-'+self.settings.sectionId+' option'), function(index,el) {
        $(this).text($(this).val());
      });
      $('._soulout').removeClass('_soulout');
      $('._unavailable').removeClass('_unavailable');
      $('.kt_flash_lable').text('');
      _.forEach(self.productSingleObject.variants, function(value) {
        if(value.option1 === currentVariant.option1){
          options2.push(value.option2)
          if(value.option2 === currentVariant.option2){
            options3.push(value.option3)
          }
        }
        if(value.title === currentVariant.title){
          // console.log(value)
        }
        if(value.option2 == currentVariant.option2 && value.option3 == currentVariant.option3){
          // console.log(value)          
          $.each($('#'+optitonSelector1+' option'), function(index,el) {
            if(value.option1 == $(this).attr('value')){
              $('._'+_handleize($(this).val())+'[data-change-option="'+optitonSelector1+'"]').find('.kt_price_lable').html(theme.Currency.formatMoney(value.price, theme.moneyFormat));
              if(theme.function.multiCurrency == true && cookieCurrency !== null && cookieCurrency !== shopCurrency){
                Currency.convertAll(shopCurrency,cookieCurrency,self.selectors.template+' .kt_price_lable span.money');
              }
            }
          });
        }
        if(value.available == false){
          // console.log(value)
          if (value.option1 == currentVariant.option1 && value.option2 == currentVariant.option2) {
            $.each($('#'+optitonSelector3+' option'), function(index,el) {
              if(value.option3 == $(this).attr('value')){
                $(this).text($(this).text()+' - Soldout');
                $('._'+_handleize(value.option3)+'[data-change-option="'+optitonSelector3+'"]').addClass('_soulout').find('.kt_flash_lable').text(' - Soldout');
              }
            });
          } else if(value.option1 == currentVariant.option1 && value.option3 == currentVariant.option3) {
            $.each($('#'+optitonSelector2+' option'), function(index,el) {
              if(value.option2 == $(this).attr('value')){
                $(this).text($(this).text()+' - Soldout');
                $('._'+_handleize(value.option2)+'[data-change-option="'+optitonSelector2+'"]').addClass('_soulout').find('.kt_flash_lable').text(' - Soldout');
              }
            });
          }
        }
      });
      options2 = $.unique(options2);
      options3 = $.unique(options3);
      $.each($('#'+optitonSelector2+' option'), function(index,el) {
        if(_.indexOf(options2,$(this).attr('value')) == -1){
          $('._'+_handleize($(this).val())+'[data-change-option="'+optitonSelector2+'"]').addClass('_unavailable').find('.kt_flash_lable').text(' - Unavailable');
        }
      });
      $.each($('#'+optitonSelector3+' option'), function(index,el) {
        if(_.indexOf(options3,$(this).attr('value')) == -1){
          $('._'+_handleize($(this).val())+'[data-change-option="'+optitonSelector3+'"]').addClass('_unavailable').find('.kt_flash_lable').text(' - Unavailable');
        }
      });
    },

    _onReSize: function() {
      var self = this;
      var iframe = $(self.selectors.template+" iframe#resize-image-product");
      iframe.each(function() {
        var $this = $(this);
        $(this.contentWindow || this).on("resize", function() {
          if ($(window).width() >= 768) {
            setTimeout(function() {
              if (self.selectors.template == '#ProductSection-product-template' && self.dataSettings.useMaxheight) {
                if(self.dataSettings.layoutSection === 7){
                  $(self.selectors.template+' .related_tags').css('max-height', $this.height());
                }
                if(self.dataSettings.layoutSection === 9){
                  $(self.selectors.template+' .content-summary').css('max-height', $this.height() - 94);
                }
                else if(self.dataSettings.layoutSection === 6){
                  $(self.selectors.template+' .content-summary').css('max-height', $this.height() - 120);
                }
                else if(self.dataSettings.layoutSection === 5){
                  $(self.selectors.template+' .content-summary').css('max-height', $this.height() - 200);
                }
                else{
                  $(self.selectors.template+' .content-summary').css('max-height', $this.height() - 10);
                }
              }
              if (self.selectors.template == '#ProductSection-quickview-template') {
                $('#myModal .content-summary').css('max-height', $this.height() - 10);
              }
            }, 100)
          } else {
            $('.content-summary').css('max-height', '');
          }
        })
      })
    },

    _stickyAddCart: function() {
      var self = this;
      if ($('.kt-stickyAddCart').length > 0) {
        $(window).scroll(function() {
          var $this = $('.kt-stickyAddCart');
          if ($(window).scrollTop() > $('#AddToCartText-product-template').offset().top + 60 && $('.kt-stickyAddCart').not('.fixed')) {
            var headerHeight = $('[data-sticky="true"] .header-wrap-stick').outerHeight() || 0;
            $this.addClass('fixed')
            if($('.kt-stickyAddCart .position-fixed').hasClass('top')){
              $('.kt-stickyAddCart .position-fixed.top').css('top',headerHeight+'px');
            }
          }
          else if($(window).scrollTop() <= $('#AddToCartText-product-template').offset().top){
            $this.removeClass('fixed')
            if($('.kt-stickyAddCart .position-fixed').hasClass('top')){
              $('.kt-stickyAddCart .position-fixed.top').css('top','-100%');
            }
          }
        });
        $('.kt-stickyAddCart .js-product-form__item--quantity input[name="quantity"]').on('change', function(event) {
          var count = $(this).val();
          var currentOnclick = $(this).parent().find('.add_to_cart_button[onclick]').attr('onclick');
          if ($('.kt-stickyAddCart').find('input[name="quantity"]').length === 1) {
            var id = $(this).parents('.btns-group').find('.add_to_cart_button[onclick]').attr('data-pid');
            $(this).parents('.btns-group').find('.add_to_cart_button[onclick]').attr("onclick", "$(this).addClass(\'loading\').removeClass(\'loaded\');Shopify.KT_addItem("+id+","+count+")");
          } else if ($('.kt-stickyAddCart').find('form[data-pr-vrs] input[name="quantity"]').length === 1) {
            $('.kt-stickyAddCart').find('form[data-pr-vrs] input[name="quantity"]').val(count);
          }
        });
      }
    },

    _initImageSwitch: function() {
      if (!$(this.selectors.productThumbImages).length) {
        return;
      }

      var self = this;
      var $originalSelectorId = $(this.selectors.originalSelectorId);
      var $variantSelectorId = this.selectors.variantSelectorId;
      $(document).on('click',this.selectors.productThumbImages, function(evt) {
        evt.preventDefault();
        var $el = $(this);
        var template = self.selectors.template;
        if(typeof $el.attr('data-id') !== "undefined" && $el.attr('data-id') !== '' && $el.attr('title') !== self.productSingleObject.title ){
          $($variantSelectorId+ ' span').text($el.attr('title')).animate({"font-size": "14px"}, 400).animate({"font-size": "13px"}, 500);
          goto = false;
          var options = $el.attr('title').split(' / ');
          $(template +' .fake_select li').removeClass('selected');
          $(options).each(function(index, opiton) {
            var options_change = $(template +' option[value="'+opiton+'"]').val();
            var $options_change_ = $(template +' option[value="'+opiton+'"]').parent();
            $(template +' .fake_select li._'+_handleize(opiton)).addClass('selected');
            if(opiton != self.productSingleObject.title){
              $(template +' label[data-change-label="SingleOptionSelector-'+index+'--'+self.settings.sectionId+'"] .text').text(opiton);
              $(template +" .swatches-selected-name[data-change-label='SingleOptionSelector-"+index+"--"+self.settings.sectionId+"] .name").html(opiton);
            }
            if(options_change != $options_change_.val() ){
              $options_change_.val(options_change).change();
            }
          });
          var val_id = $el.attr('data-id');
          $originalSelectorId.val(val_id).change();
          if(($(this).parents("div.product-page").data('enable-history-state')) == true){
            var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + val_id;
            window.history.replaceState({path: newurl}, '', newurl);
          }
        }
        var imageSrc = $el.attr('href');
        self._setActiveThumbnail(imageSrc);
      });
    },

    _setActiveThumbnail: function(src) {
      // If there is no element passed, find it by the current product image
      if (typeof src === 'undefined') {
        src = $(this.selectors.productFeaturedImage).attr('href');
      }
      // Set active thumbnails (incl. slick cloned thumbs) with matching 'href'
      var $thumbnail = $(this.selectors.productThumbs + ' li[data-src="' + src + '"]');
      var clone_length = ($(this.selectors.productThumbs+' .slick-cloned').length / 2) || 0;
      slideIndex = $thumbnail.closest('.slick-slide').not('.slick-cloned').index() - clone_length;
      if($(this.selectors.productPhotos+' .slick-list').length !== 0){$(this.selectors.productPhotos).slick('slickGoTo', slideIndex);}
    },

    _switchImage: function(image, zoomImage) {
      // $(this.selectors.productFeaturedImage).attr('src', image);
      // $(this.selectors.productFeaturedImage).parent().attr('href', image);
    },

    _initThumbnailSlider: function() {
      var self = this;
      if (self.thumbnailOptions) {
        options = self.thumbnailOptions;
      } else {
        var options = $(self.selectors.productThumbs).data();
            options.prevArrow = '<button type="button" class="btn btn-primary slick-prev"><i class="fa fa-caret-left" aria-hidden="true"></i></button>';
            options.nextArrow = '<button type="button" class="btn btn-primary slick-next"><i class="fa fa-caret-right" aria-hidden="true"></i></button>';
            options.speed = 300;
            options.adaptiveHeight = true;
            options.focusOnSelect = true;
        self.thumbnailOptions = options;
      }
      // console.log(options)
      $(this.selectors.productThumbs+':not(.first) li:not(.slick-cloned)').eq(options.slidesToShow-1).addClass('last');
      var imgLarge = new Image();
      imgLarge.src = $(self.selectors.productThumbs+':not(.first)').find('img').first().attr('src'); 
      imgLarge.onload = function () {
        $(self.selectors.productThumbs+':not(.first)').on('init', function(event, slick){
          if(initialSlide !== 0){
            setTimeout(function(){
              $(self.selectors.productThumbs).slick('slickGoTo', initialSlide);
              initialSlide = 0;
            }, 2000);
          }
        });
        $(self.selectors.productThumbs+':not(.first)').attr('data-items',options.slidesToShow).slick(options);

        // On after slide change
        $(self.selectors.productThumbs+':not(.first)').on('beforeChange', function(event, slick, currentSlide, nextSlide){
          var options_ = $(self.selectors.productThumbs+':not(.first)').slick('getSlick');
          var lastSlickActive = options_.currentSlide + options_.options.slidesToShow;
          $(self.selectors.productThumbs+':not(.first)').find('li.last').removeClass('last');
          $(self.selectors.productThumbs+':not(.first) li:not(.slick-cloned)').eq(lastSlickActive).addClass('last');
        });
      }
    },

    _destroyThumbnailSlider: function() {
      $(this.selectors.productThumbs).slick('unslick');
      this.settings.sliderActive = false;
    },
    
    _initPhotoSlider: function() {
      var self = this;
      if (self.photoOptions) {
        options = self.photoOptions;
      } else {
      var options = $(self.selectors.productPhotos).data();
          options.prevArrow = '<button type="button" class="btn btn-primary slick-prev"><i class="fa fa-caret-left" aria-hidden="true"></i></button>';
          options.nextArrow = '<button type="button" class="btn btn-primary slick-next"><i class="fa fa-caret-right" aria-hidden="true"></i></button>';
          options.speed = 300;
      if(self.dataSettings.layoutSection !== 4 && self.dataSettings.layoutSection !== 9){
          options.fade = true;
          options.cssEase = 'linear';
      }
      self.photoOptions = options;
      }
      if(self.dataSettings.layoutSection == 3 && $(window).width() > 768){
        return false;
      }
      // console.log(options)
      var imgLarge = new Image();
      imgLarge.src = $(this.selectors.productPhotos+':not(.first)').find('img').first().attr('data-srcbase'); 
      imgLarge.onload = function () {
        if ($(self.selectors.productPhotos).length == 0) {
          $(self.selectors.productPhotos+':not(.first)').on('init', function(event, slick){
            if(initialSlide !== 0){
              setTimeout(function(){
                $(self.selectors.productPhotos).slick('slickGoTo', initialSlide);
                initialSlide = 0;
              }, 2000);
            }
          });
        }
        $(self.selectors.productPhotos+':not(.first)').slick(options);
        self._initPhotoSwipeFromDOM();

        // On after slide change
        $(self.selectors.productPhotos+':not(.first)').on('beforeChange', function(event, slick, currentSlide, nextSlide){
          if ($(self.selectors.productPhotos).length > 0){
            if ($(self.selectors.productPhotos+':not(.first)').find('.slick-slide').length == nextSlide + 1 || nextSlide == 0) {
              $(self.selectors.productPhotos).slick('slickGoTo', nextSlide);
            }
          }
          if ($(slick.$slides[nextSlide]).find('.gallery-video').length == 0){
            $(self.selectors.productPhotos).find('video.video-element').trigger('pause');
          }
        });
        if (theme.MenuReposive.is_mobile() == false && theme.function.photoZoom){
          KT.loadScript('zoom', function(e,l){
            if (l == 'ok') {
              $.each($(self.selectors.template+' .SlickPhotoswipGallery .slick-active .product-single__photos-item'), function(index, val) {
                $(this).zoom({url: $(this).find('a img').attr('data-srcfix')});
              });
              $(self.selectors.template+' .SlickPhotoswipGallery').on('afterChange', function(event, slick, currentSlide, nextSlide){
                $(self.selectors.template+' .SlickPhotoswipGallery .product-single__photos-item').trigger('zoom.destroy'); // remove zoom
                $.each($(self.selectors.template+' .SlickPhotoswipGallery .slick-active .product-single__photos-item'), function(index, val) {
                  $(this).zoom({url: $(this).find('a img').attr('data-srcfix')});
                });
              });
              $(document).on('click', 'img.zoomImg', function(event) {
                event.preventDefault();
                $(self.selectors.template+' img[data-srcfix="'+theme.Images.removeProtocol(event.target.currentSrc)+'"]').trigger('click');
              });
            }
          })
        }
      }
    },

    _destroyPhotoSlider: function() {
      $(this.selectors.productPhotos).slick('unslick');
    },

    _initPhotoSwipeFromDOM: function() {
      var self = this;
      if (self.dataSettings.wide) {
        KT.loadScript('photo-swipe', function(e,l){          
          if (l == 'ok') {
            theme.initPhotoSwipeFromDOM(self.selectors.template+' .SlickPhotoswipGallery','.product-single__photos-item:not(.slick-cloned)','IMG', function(currentIndex, currentItem){
              if($(self.selectors.template+' .SlickPhotoswipGallery .slick-list').length !== 0){
                var itemSlick = $(self.selectors.template+' .SlickPhotoswipGallery').find('.slick-slide:not(.slick-cloned) .product-single__photos-item[data-src="'+currentItem.src+'"]');
                if($(itemSlick).length !== 0){
                  var clone_length = ($(self.selectors.template+' .SlickPhotoswipGallery .slick-slide.slick-cloned').length / 2) || 0;
                  var slideIndex = $(itemSlick).closest('.slick-slide').index() - clone_length;
                  $(self.selectors.template+' .SlickPhotoswipGallery').slick('slickGoTo', slideIndex);
                }
              }
            });
          }
        })
      }
    },

    _initStickySummary: function() {
      var thissummary = $('.summary.entry-summary');
      var thissummaryw = thissummary.width();
      var thissummaryo = thissummary.offset();
      var thisposition = $(window).scrollTop() + thissummary[0].getBoundingClientRect().top + (thissummary.outerHeight() - thissummary.height());
      $(window).scroll(function() {
        // console.log(thissummary[0].getBoundingClientRect().top + thissummary.height())
        var thissummaryh = thissummary.outerHeight() + 50;
        if (thissummary !== undefined && $(window).width() >= 768) {
          if ($('.product-page').height() - 30 > $(window).scrollTop() + thissummaryh - thisposition) {
            if ($(window).scrollTop() >= thisposition){
              var transalte = $('#header.on_sticky').length > 0 ? 65 : 20;
              thissummary.not('.fixed').addClass('fixed').removeClass('maxscroll').css({'top': transalte+'px','width': thissummaryw+'px','transform': 'none'});
            }else if($(window).scrollTop() < thisposition){
              thissummary.removeClass('fixed maxscroll').removeAttr('style');
            }
          } else if (thissummary.hasClass('maxscroll') == false && $('.product-page').height() - 30 <= thissummaryh + thissummary.offset().top) {
            var transalte = $('#header.on_sticky').length > 0 ? $('.product-page').height() - thissummaryh + 65 : $('.product-page').height() - thissummaryh + 20;
            thissummary
            .addClass('maxscroll')
            .removeClass('fixed')
            .removeAttr('style')
            .css({'transform': 'translate3d(0px,'+transalte+'px,0px)','-webkit-transform': 'translate3d(0px,'+transalte+'px,0px)','moz-transform': 'translate3d(0px,'+transalte+'px,0px)','-ms-transform': 'translate3d(0px,'+transalte+'px,0px)','-o-transform': 'translate3d(0px,'+transalte+'px,0px)'});
          }
        }
      });
    },

    _updateAddToCart: function(evt) {
      var variant = evt.variant;
      var self = this;
      var template = self.selectors.template;
      var sectionId = self.settings.sectionId;
      if($('#SingleOptionSelector-0--'+sectionId+'').val() !== undefined ){
        $('#callBackVariant--'+sectionId).attr('class','_'+_handleize($('#SingleOptionSelector-0--'+sectionId).val()));
        if($('#SingleOptionSelector-2--'+sectionId+'').val() !== undefined ){
          $('#callBackVariant--'+sectionId).addClass('_'+_handleize($('#SingleOptionSelector-2--'+sectionId).val()));
        }
        if($('#SingleOptionSelector-1--'+sectionId+'').val() !== undefined ){
          $('#callBackVariant--'+sectionId).addClass('_'+_handleize($('#SingleOptionSelector-1--'+sectionId).val()));
        }
      }
      if (variant) {
        this._changeVariants(variant);
        this._updateGallery(evt,variant);
        $(this.selectors.variantSelectorId+ ' span').text(variant.title).animate({"font-size": "14px"}, 400).animate({"font-size": "13px"}, 500);
        $(this.selectors.productPrices).removeClass('visibility-hidden').attr('aria-hidden', 'true');
        if (variant.available) {
          $(template).find('.kt_progress_bar').removeClass('d-none');
          $(template).find('.out-of-stock').addClass('d-none');
          $(template).find('.availalbe.text-primary').text(theme.strings.inStock);
          $(template).find('.js-product-form__item--quantity').removeClass('d-none');
          if (variant.inventory_quantity > 0 && variant.inventory_management !== null) {
            $(template).find('.meta .show-iq').removeClass('d-none').find('span').text(variant.inventory_quantity);   
            theme.stockCountdown.updateMeter(template + ' .kt_progress_bar_pr',variant.inventory_quantity)
            $(template).find('.meta .show-iq_').removeClass('min');
          }else{
            $(template).find('.meta .show-iq').addClass('d-none');
            $(template).find('.meta .show-iq_').addClass('min');
          }
          if($(template).find('.summary .discount-code').length > 0){
            var btn = $(template).find('.summary .discount-code a.discount-btn'), hrefcrr = btn.attr('href'), vridcrr = btn.attr('href').split('/')[2].split(':')[0];
            btn.attr('href', hrefcrr.replace(vridcrr, variant.id));
          }
        } else {
          $(template).find('.kt_progress_bar').addClass('d-none');
          $(template).find('.out-of-stock').removeClass('d-none');
          $(template).find('.availalbe.text-primary').text(theme.strings.outOfStock);
          $(template).find('.js-product-form__item--quantity,.meta .show-iq').addClass('d-none');
          $(template).find('.meta .show-iq_').addClass('min');
        }
        if (variant.available || variant.available && variant.inventory_quantity <= 0 && variant.inventory_policy != 'deny') {
          $(this.selectors.addToCart).prop('disabled', false);
          if (variant.inventory_quantity <= 0 && variant.inventory_policy != 'deny'){
            $(this.selectors.addToCartText).text(theme.strings.preOrder);
          }else{
            $(this.selectors.addToCartText).text(theme.strings.addToCart);
          }
          $(template).find('.shopifyPaymentButton').show()
        } else {
          $(this.selectors.addToCart).prop('disabled', true);
          $(this.selectors.addToCartText).text(theme.strings.soldOut);
          $(template).find('.shopifyPaymentButton').hide()
        }
      }
      else {
        if(goto == true){
          var option1 = $('#SingleOptionSelector-0--'+sectionId).val();
          var option1_cr = _handleize(option1);
          var options = $('#SingleOptionSelector-0--'+sectionId+' option[value="'+option1+'"]').attr('data-first-variant').split(' / ');
          var options_title = $('#SingleOptionSelector-0--'+sectionId+' option[value="'+option1+'"]').attr('data-first-variant-title').split(' / ');
          $(template +' .fake_select li').removeClass('selected');
          $(options).each(function(index, option) {
            var option_title = options_title[index];
            if (options.length == 3 && index == 1 && optionIndex == 'SingleOptionSelector-1--'+ sectionId) {
              option = _handleize(optionValue);
              option_title = optionValue;
            }
            if (options.length == 3 && index == 2 && optionIndex == 'SingleOptionSelector-1--'+ sectionId) {
              var vr_available = _.find(self.productSingleObject.variants, { 'option1': option1,'option2': optionValue});
              option = _handleize(vr_available.option3);
              option_title = vr_available.option3;
            }
            if(index === 0 && option !== option1_cr ){
              $(template +' .fake_select li._'+option1_cr).addClass('selected');
            }
            else{
              var options_change = $(template +" option[value='"+option_title+"']").val();
              var $options_change_ = $(template +" option[value='"+option_title+"']").parent();
              $(template +' .fake_select li._'+option).addClass('selected');
              $('label[data-change-label="SingleOptionSelector-'+index+'--'+sectionId+'"] .text').text(option_title);
              if(options_change != $options_change_.val()){
                $options_change_.val(options_change).change();
              }
            }
          });
        }
      }
    },

    _updateImages: function(evt) {
      var variant = evt.variant;
      if (variant.featured_image == undefined) {return false}
      variantImage = variant.featured_image.src;
      var sizedImgUrl = theme.Images.getSizedImageUrl(variantImage, this.settings.imageSize);
      if($(this.selectors.template).data('use-thumb') === true){
        if(variantImage != undefined && goto == true ){
          var $thumbnail = $(this.selectors.productThumbs + ' li[data-src="' + theme.Images.removeProtocol(variantImage) + '"]');
          var clone_length = $(this.selectors.productThumbs+' .slick-cloned').length / 2;
          slideIndex = $thumbnail.closest('.slick-slide').not('.slick-cloned').index() - clone_length;
          if($(this.selectors.productPhotos+' .slick-list').length !== 0){$(this.selectors.productPhotos).slick('slickGoTo', slideIndex);}
          if($(this.selectors.productThumbs+' .slick-list').length !== 0){
            $(this.selectors.productThumbs).slick('slickGoTo', slideIndex);
            $(this.selectors.productThumbImages).removeClass('active-thumb');
            $thumbnail.addClass('active-thumb');
          }else{
            $(this.selectors.productThumbImages).removeClass('active-thumb');
            $thumbnail.addClass('active-thumb');
          }
        }
      }else{
        if(variantImage != undefined && goto == true ){
          var $photo = $(this.selectors.productPhotos + ' li[data-src="' + theme.Images.removeProtocol(variantImage) + '"]');
          var count = 0;
          $.each($(this.selectors.productPhotos + ' li[data-src]'), function(index, val) {            
            if ($(this).closest('.slick-slide').hasClass('slick-cloned')) {count++;console.log($(this).closest('.slick-slide.slick-cloned'))} else {return false;}
          });
          slideIndex = $photo.closest('.slick-slide').index() >= 0 ? $photo.closest('.slick-slide').index() - count : 0;
          if($(this.selectors.productPhotos+' .slick-list').length !== 0){$(this.selectors.productPhotos).slick('slickGoTo', slideIndex);}
        }
      }
    },
    
    _updateGallery: function(evt,variant) {
      var self = this;
      var dataJs = this.dataJs;
      var imgPos = variant.featured_image ? variant.featured_image.position : parseInt($(this.selectors.dataJs).attr('data-vrimgpos'));
      var imgspr = dataJs.imgspos.split(','), imgsArray = dataJs.primgs.split(','), templateSlick = self.settings.sectionId;
      var htmlPhotoImages = '<div class="photos-wrapper"><ul class="list-unstyled mb-0 SlickPhotoswipGallery product-single__photos product-single__photos-'+templateSlick+'" data-slides-to-show="'+self.photoOptions.slidesToShow+'">';
      if ($(self.selectors.productThumbImages).length >= 1) {
        var htmlThumbImages = '<div class="thumbnails-wrapper" style="display:none;"><ul class="list-unstyled mb-0 product-single__thumbnails product-single__thumbnails-'+templateSlick+'" data-slides-to-show="'+self.thumbnailOptions.slidesToShow+'">';   
      }
      var last_imgPos = $(this.selectors.dataJs).attr('data-vrimgpos');
      if(_.indexOf(imgspr,imgPos.toString()) !== -1 && last_imgPos !== imgPos.toString() && this.dataSettings.gallery){
        var imgsPos = [];
        _.forEach(imgspr, function(value,idx0) {
          if(parseInt(value) >= imgPos){
            if (parseInt(value) == imgsArray.length) {
              imgsPos.push(parseInt(imgspr[idx0]));
              imgsPos.push(parseInt(value));
              return false;
            }
            else{
              imgsPos.push(parseInt(value));
              imgsPos.push(parseInt(imgspr[idx0+1]));
              return false;
            }
          }
        });
        if(dataJs.vrsvideo.length > 0 && dataJs.vrsvideo !== "undefined"){
          var vrsVideoArr = [];
          _.forEach(dataJs.vrsvideo.split(','), function(value, idx) {
            var item = new Object();
            item['position'] = value.split(':')[0];
            item['thumb'] = value.split('|http')[0].split(':')[2];
            item['url'] =  value.split('|http')[1].split(':')[1];
            vrsVideoArr.push(item)
          });
        }
        var newgallery = false;
        if($.unique($.merge(JSON.parse($(this.selectors.dataJs).attr('data-curpos')),imgsPos)).length > 2){
          newgallery = true;
        }
        if(parseInt(imgsPos[0]) == parseInt(imgsPos[1])){
          newgallery = true;
        }
        if(imgspr.length > 1 && newgallery){
          $(this.selectors.template +' .loadingChangeImage').css('display','block');
          // var containerImagesW = $(this.selectors.template +' .images').width();
          // var containerImagesH = $(this.selectors.template +' .product-images').height();
          // $(this.selectors.template +' .images').css({'width':containerImagesW,'height':containerImagesH});
          $(this.selectors.dataJs).attr('data-curpos','['+imgsPos[0]+","+imgsPos[1]+']');
          variant.featured_image ? $(this.selectors.dataJs).attr('data-vrimgpos',variant.featured_image.position) : $(this.selectors.dataJs).attr('data-vrimgpos',imgsPos[0]);
          var imgsprw = dataJs.primgswidth.toString().split(','), imgsprh = dataJs.primgsheight.toString().split(',');
          if($(this.selectors.productThumbs).length > 0){
            var image_size = theme.Images.imageSize($(this.selectors.productThumbs+" .product-single__thumbnail-image:first").attr('src'));
          }
          var image_size_ = image_size || '110x110@2x';
          var count_img = 0;
          var kt_visible = false;
          _.forEach(imgsArray, function(value, idx) {
            kt_visible = false;
            // console.log(parseInt(imgsPos[0]), idx+1, parseInt(imgsPos[1]))
            if(parseInt(imgsPos[0]) <= idx+1 && parseInt(imgsPos[1]) > idx+1){
              // console.log(1)
              kt_visible = true;
            }
            if(parseInt(imgsPos[0]) == parseInt(imgsPos[1]) && parseInt(imgsPos[0] == idx+1)){
              // console.log(2)
              kt_visible = true;
            }
            if(parseInt(imgsPos[0]) == parseInt(imgsPos[1]) && parseInt(imgsPos[0]) == idx+1 && parseInt(imgsPos[1]) == imgsArray.length){
              // console.log(3)
              kt_visible = true;
            }
            if(imgspr[imgspr.length - 2] !== imgspr[imgspr.length - 1] && parseInt(imgsPos[1]) == idx+1 && parseInt(imgsPos[1]) == imgsArray.length){
              // console.log(3)
              kt_visible = true;
            }
            if(kt_visible == true){
              var fileExt = _.last(value.split('.')), img_url_photo = value.replace('.'+fileExt, '_{width}x.'+fileExt);
              if ($(self.selectors.productThumbs).length > 0) {
                var img_url_thumb = value.replace('.'+fileExt, '_'+image_size+'.'+fileExt);
              }
              var altobj = _.find(self.productSingleObject.variants, function(o) { return o.id == dataJs.vrsFeaturedImg[idx].id});
              var alt = altobj !== undefined ? altobj.featured_image.alt : self.productSingleObject.title;
              if (alt !== null && alt.indexOf('||video:') !== -1 ) {
                var gallery = ' gallery-video';
                var kt_video = true;
                var vUrl = alt.split('||video:')[1];
                var fImageId = altobj.featured_image.id;
              }else {
                var kt_video = false;
                var gallery = ' gallery-image';
              }
              htmlPhotoImages += '<li class="product-single__photos-item'+ gallery +'" data-src="'+ dataJs.imgurl.replace('kiti', value)+'">';
              htmlPhotoImages += '<a href="javascript:void(0)" class="product-single__photo product-single__photo--'+templateSlick+'" style="max-width:'+imgsprw[idx]+'px">';
              htmlPhotoImages += '<img class="product-single__photo-image img-responsive lazyload" src="'+ dataJs.imgurl.replace( 'kiti', value.replace('.'+fileExt, '_'+image_size_+'.'+fileExt)) +'" data-srcbase="'+ dataJs.imgurl.replace('kiti', value.replace('.'+fileExt, '_'+image_size_+'.'+fileExt)) +'" data-src="'+ dataJs.imgurl.replace('kiti', img_url_photo) +'" data-widths="[180, 360, 540, 720, 900, 1080]" data-aspectratio="'+imgsprw[idx] / imgsprh[idx]+'" data-srcfix="'+dataJs.imgurl.replace('kiti', value)+'" data-size="'+imgsprw[idx]+'x'+imgsprh[idx]+'" data-sizes="auto" >';
              if (kt_video && vUrl.indexOf('.mp4') !== -1) {
                htmlPhotoImages += '<div class="video_content"><video class="video-element" controls="controls" loop poster="'+dataJs.imgurl.replace('kiti', value)+'"><source type="video/mp4" src="'+vUrl+'"></video></div>';
              }
              htmlPhotoImages += '</a></li>';
              if( $(self.selectors.productThumbs).length > 0){
                htmlThumbImages += '<li class="grid__item product-single__thumbnails-item'+ gallery +'">';
                htmlThumbImages += '<a href="'+dataJs.imgurl.replace('kiti', value)+'" class="product-single__thumbnail product-single__thumbnail--'+templateSlick+'"';
                htmlThumbImages += ' title="'+dataJs.vrsFeaturedImg[idx].title+'"';
                htmlThumbImages += ' data-src="'+dataJs.imgurl.replace('kiti', value)+'"';
                htmlThumbImages += ' data-id="'+dataJs.vrsFeaturedImg[idx].id+'">';
                htmlThumbImages += '<img class="product-single__thumbnail-image img-responsive" src="'+ dataJs.imgurl.replace('kiti', img_url_thumb) +'" alt="'+self.productSingleObject.title+'">';
                if (kt_video) {
                  htmlThumbImages += '<div class="btn play';
                  if(vUrl.indexOf('.mp4') == -1){
                    htmlThumbImages += ' kt_openvd_'+fImageId;
                  }
                  htmlThumbImages += '"><i class="fa fa-play" aria-hidden="true"></i></div>';
                }
                if (kt_video && vUrl.indexOf('.mp4') == -1){
                  KT.loadScript('magnific-popup', function(e,l){          
                    if (l == 'ok') {self._checkedVariantVideo(vUrl,fImageId)}
                  })
                }
                htmlThumbImages += '</a></li>';
              }
              count_img++
            }
          });
          htmlPhotoImages += '</ul></div>';
          if ($(self.selectors.productThumbImages).length > 0) {
            htmlThumbImages += '</ul></div>';
          }
          var templateImages = self.selectors.template;
          $(this.selectors.template).find('.photos-wrapper').addClass('first');
          $(this.selectors.template).find('.thumbnails-wrapper').addClass('first');
          if( count_img > 1){
            $(templateImages +' .main-image:not(.first)').removeAttr('style');
            $(templateImages +' .thumbnails-wrapper:not(.first)').removeAttr('style');
            if ($(templateImages + ' #product-thumb-slide').hasClass('vertical-carousel')) {              
              $(templateImages + ' #product-photo-slide').addClass('col-md-10 col-lg-10');
              $(templateImages + ' #product-thumb-slide').addClass('col-md-2 col-lg-2').removeClass('order-2');
            }
          }else{
            $(templateImages +' .main-image').css({'width': '100%'});
            $(templateImages +' .thumbnails-wrapper').css('display','none');
            if ($(templateImages + ' #product-thumb-slide').hasClass('vertical-carousel')) {              
              $(templateImages + ' #product-photo-slide').removeClass('col-md-10 col-lg-10');
              $(templateImages + ' #product-thumb-slide').removeClass('col-md-2 col-lg-2').addClass('order-2');
            }
          }
          $(this.selectors.productPhotos).first().addClass('first');
          $(this.selectors.productThumbs).first().addClass('first');
          if($(self.selectors.productThumbs+' .slick-list').length !== 0){
            this._destroyThumbnailSlider();
          }
          if($(self.selectors.template+' .SlickPhotoswipGallery .slick-list').length !== 0){
            this._destroyPhotoSlider();
          }
          if($(this.selectors.productThumbs).length > 0){
            $(this.selectors.template).find('#product-thumb-slide').append(count_img > 1 ? htmlThumbImages.replace(' style="display:none;"','') : htmlThumbImages)
            .animate({'opacity': 1},'0', function() {
              var imgLarge = new Image();
              imgLarge.src = $(htmlThumbImages).find('img').first().attr('src'); 
              imgLarge.onload = function () {
                // $(self.selectors.template +' .loadingChangeImage').css('display','none');
                self._initThumbnailSlider();
                $(self.selectors.template).find('.thumbnails-wrapper.first').animate({'opacity': 0},'100', function() {
                  $(this).remove();
                });
                if($(self.dataSettings.useThumb)){
                  self._setActiveThumbnail();
                }
              }
            })
          }
          $(this.selectors.template).find('.main-image-wapper').append(htmlPhotoImages)
          .animate({'opacity': 1},'0', function() {
            var imgLarge = new Image();
            imgLarge.src = $(htmlPhotoImages).find('img').first().attr('src'); 
            imgLarge.onload = function () {
              // $(self.selectors.template +' .loadingChangeImage').css('display','none');
              self._initPhotoSlider();
              $(self.selectors.template +' .images').removeAttr('style')
              $(self.selectors.template).find('.photos-wrapper.first').animate({'opacity': 0},'100', function() {
                $(this).remove();
              })
            }
          })

          var vrvideo = _.find(vrsVideoArr, function(o) { return o.position == imgsPos[0] });
          if(vrvideo !== undefined){
            KT.loadScript('magnific-popup', function(e,l){          
              if (l == 'ok') {self._checkedVariantVideo(vrvideo.url)}
            })
          }else{
            $('.kt_openvd_'+this.productSingleObject.id).addClass('d-none');
          }
        }
      }
    },

    _checkVariantVideo: function() {
      var self = this;
      var dataJs = this.dataJs;
      var imgspr = dataJs.imgspos.split(',');
      var imgPos = this.variants.currentVariant.featured_image ? this.variants.currentVariant.featured_image.position : parseInt($(this.selectors.dataJs).attr('data-vrimgpos'));
      var imgsPos = [];
      _.forEach(imgspr, function(value,idx0) {
        if(parseInt(value) >= imgPos){
          imgsPos.push(parseInt(value));
          imgsPos.push(parseInt(imgspr[idx0+1]));
          return false;
        }
      });
      if(dataJs.vrsvideo.length > 0 && dataJs.vrsvideo !== "undefined"){
        var vrsVideoArr = [];
        _.forEach(dataJs.vrsvideo.split(','), function(value, idx) {
          var item = new Object();
          item['position'] = value.split(':')[0];
          item['thumb'] = value.split('|http')[0].split(':')[2];
          item['url'] =  value.split('|http')[1].split(':')[1];
          vrsVideoArr.push(item)
        });
      }
      var vrvideo = _.find(vrsVideoArr, function(o) { return o.position == imgsPos[0] });
      if(vrvideo !== undefined){
        KT.loadScript('magnific-popup', function(e,l){          
          if (l == 'ok') {self._checkedVariantVideo(vrvideo.url)}
        })
      }else{
        $('.kt_openvd_'+this.productSingleObject.id).addClass('d-none');
      }
      if($('div[class~="play"][data-video]').length){
        KT.loadScript('magnific-popup', function(e,l){
          if (l == 'ok') {
            var callbackTimer = setInterval(function() {
              if (typeof $.fn.magnificPopup == 'function') {
                clearInterval(callbackTimer);
                $.each($('div[class~="play"][data-video]'), function(idx, el) {
                  self._checkedVariantVideo($(this).attr('data-video'),$(this).attr('data-imgid'))
                });
              }
            }, 100);           
          }
        })
      }
    },

    _checkedVariantVideo: function(url,btnId) {
      var btnId = btnId == undefined ? self.productSingleObject.id : btnId;
      $('.kt_openvd_'+btnId).removeClass('d-none');
      if(url.indexOf('.mp4') !== -1){
        $('.kt_openvd_'+btnId)
        .magnificPopup({
          items: [
            {
              src: '<div class="white-popup"><div class="white-popupcontent"><video class="amp-page amp-video-element" id="myVideo_product" controls="controls" autoplay><source type="video/mp4" src="'+url+'"></video></div></div>',
              type: 'inline'
            }
          ],
          type: 'image'
        });
      }else if(url.indexOf('youtube.com') !== -1 || url.indexOf('vimeo.com') !== -1){
        $('.kt_openvd_'+btnId)
        .magnificPopup({
          items: [
            {
              src: url,
              type: 'iframe'
            }
          ],
          type: 'image'
        });
      }
    },

    _create360: function(variant) {
      var dataJs = this.dataJs
          self = this;
      if(dataJs.imgspos360.length === 0){
        return false;
      }
      // Check 360 available
      var imgsPos360 = dataJs.imgspos360.split(','), primgs = dataJs.primgs.split(','), imgsprw = dataJs.primgswidth.toString().split(','), imgsprh = dataJs.primgsheight.toString().split(',');
      if(imgsPos360 !== '""' && imgsPos360 !== "undefined" && imgsPos360.length > 0){
        var files = [];
        _.forEach(primgs, function(value, idx) {
          if(parseInt(imgsPos360[0]) <= idx+1 && idx+1 < parseInt(imgsPos360[1])){
            var file = dataJs.imgurl.replace('kiti', value);
            files.push(file)
          }
        });
        KT.loadScript('threesixty', function(e,l){          
          if (l == 'ok') {
            theme.imgs360(files,imgsPos360,imgsprw[imgsPos360[0]],imgsprh[imgsPos360[0]],self.productSingleObject.id);
            $('.kt_open360_'+self.productSingleObject.id).removeClass('d-none')
          }
        })
      }
      if(self.settings.sectionId == 'quickview-template'){
        $(document).on('click','#myModal button.close', function () {
          $('.myModalThreeSixty.kt_'+self.productSingleObject.id).modal('hide').remove();
          $('#sizeGuide_and_shipping').remove();
        });
        $('#myModal').on('hidden.bs.modal', function () {
          $('.myModalThreeSixty.kt_'+self.productSingleObject.id).modal('hide').remove();
          $('#sizeGuide_and_shipping').remove();
        })
      }
    },
    
    _updatePrice: function(evt) {
      var variant = evt.variant;
      var self = this;
      var template = self.selectors.template;
      // Update the product price
      $(this.selectors.originalPrice).html(theme.Currency.formatMoney(variant.price, theme.moneyFormat));
      $(this.selectors.originalPrice.replace('#','.')).html(theme.Currency.formatMoney(variant.price, theme.moneyFormat));
      // Update and show the product's compare price if necessary
      if (variant.compare_at_price > variant.price) {
        $(this.selectors.comparePrice)
          .html(theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat))
          .removeClass('d-none');
        $(this.selectors.comparePrice.replace('#','.'))
          .html(theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat))
          .removeClass('d-none');
        $(this.selectors.originalPriceWrapper).addClass(this.selectors.saleClasses);
        $(this.selectors.saleLabel).removeClass('d-none');
      } else {
        $(this.selectors.comparePrice).addClass('d-none');
        $(this.selectors.comparePrice.replace('#','.')).addClass('d-none');
        $(this.selectors.saleLabel).addClass('d-none');
        $(this.selectors.originalPriceWrapper).removeClass(this.selectors.saleClasses);
      }
      if(theme.function.multiCurrency == true && cookieCurrency !== null && cookieCurrency !== shopCurrency){
        Currency.convertAll(shopCurrency,cookieCurrency,template+' .entry-summary span.money');
      }
    },

    _updateSKU: function(evt) {
      var variant = evt.variant;
      // Update the sku
      $(this.selectors.SKU).html(variant.sku);
    },

    onUnload: function() {
      this.$container.off(this.settings.namespace);
    }
  });

  return Product;
})();

theme.videoPopup = (function(url) {
  if(url.indexOf('.mp4') !== -1){
    $.magnificPopup.open({
      items: [
        {
          src: '<div class="white-popup"><div class="white-popupcontent"><video class="amp-page amp-video-element" id="myVideo_product" controls="controls" autoplay><source type="video/mp4" src="'+url+'"></video></div></div>',
          type: 'inline'
        }
      ],
      type: 'image'
    });
  }else if(url.indexOf('youtube.com') !== -1 || url.indexOf('youtu.be.com') !== -1 || url.indexOf('vimeo.com') !== -1){
    $.magnificPopup.open({
      items: [
        {
          src: url,
          type: 'iframe'
        }
      ],
      type: 'image'
    });
  }
});

theme.Quotes = (function() {
  var config = {
    mediaQuerySmall: 'screen and (max-width: 749px)',
    mediaQueryMediumUp: 'screen and (min-width: 750px)',
    slideCount: 0
  };
  var defaults = {
    accessibility: true,
    arrows: false,
    dots: true,
    autoplay: false,
    touchThreshold: 20,
    slidesToShow: 3,
    slidesToScroll: 3
  };

  function Quotes(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var wrapper = this.wrapper = '.quotes-wrapper';
    var slider = this.slider = '#Quotes-' + sectionId;
    var $slider = $(slider, wrapper);

    var sliderActive = false;
    var mobileOptions = $.extend({}, defaults, {
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    });

    config.slideCount = $slider.data('count');

    // Override slidesToShow/Scroll if there are not enough blocks
    if (config.slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = config.slideCount;
      defaults.slidesToScroll = config.slideCount;
    }

    $slider.on('init', this.a11y.bind(this));

    enquire.register(config.mediaQuerySmall, {
      match: function() {
        initSlider($slider, mobileOptions);
      }
    });

    enquire.register(config.mediaQueryMediumUp, {
      match: function() {
        initSlider($slider, defaults);
      }
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;
    }
  }

  Quotes.prototype = _.assignIn({}, Quotes.prototype, {
    onUnload: function() {
      enquire.unregister(config.mediaQuerySmall);
      enquire.unregister(config.mediaQueryMediumUp);

      $(this.slider, this.wrapper).slick('unslick');
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $('.quotes-slide--' + evt.detail.blockId + ':not(.slick-cloned)');
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
    },

    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return Quotes;
})();

window.theme = theme || {};
theme.Carousel = (function() {
  /* ---------------------------------------------
   Owl carousel
   --------------------------------------------- */
   function init(container,cloneInstal) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var carousel = this.carousel = '#Carousel-' + sectionId;
    var attr = $container.attr('data-section-type');
    if (typeof attr !== typeof undefined && attr !== false && attr === 'banner-section') {
      carousel = '#Banner-' + sectionId
    }
    $(cloneInstal === true ? $container.find('[id*="Carousel-"] .owl-carousel') : carousel+' .owl-carousel').not('.kt-carousel').not('.owl-loaded').each(function() {
      if ($(this).children().length <= 1){
        return true;
      }
      if ($(this).parents('[data-section-id="header"]').length > 0 && cloneInstal !== true){
        return true;
      }
      var config = $(this).data();
      var navText = $(this).data('nav-text');
      var animateOut = $(this).data('animateout');
      var animateIn = $(this).data('animatein');
      if(typeof animateOut != 'undefined' ){
        config.animateOut = animateOut;
      }
      if(typeof animateIn != 'undefined' ){
        config.animateIn = animateIn;
      }
      if(typeof (navText) == 'undefined' ){
        config.navText = theme.function.navText;
      }
      config.navElement = 'div';
      
      if ($(this).parent().hasClass('owl-content-fix')) {
        config.navContainer = "."+$(this).parent().find('.nav-fix').attr('data-nav');
      }
      var owl = $(this);
      if (owl.children().length <= config.items) {
        config.nav = false;
      }
      if (owl.hasClass('no-overflow') && owl.children().length > config.items + 2) {
        config.loop = true;
      } else if(owl.hasClass('no-overflow') && owl.children().length <= config.items + 2) {
        config.nav = false;
        owl.removeClass('no-overflow');
      }
      $.each(owl.find('.owl-item video'), function() {
        $(this)[0].controls = false;
      })
      owl.on('initialized.owl.carousel', function(event) {
        theme.checkProductGrid_Width();
        var itemCrr = owl.find('.owl-item').eq(event.item.index);
        $.each(owl.find('.owl-item:not(.active) video'), function() {
          $(this)[0].pause();
        })
        if (itemCrr.find('video').length > 0) {
          itemCrr.find('video')[0].play();
        }
        if (owl.find('.bgndVideo').length > 0) {
          $.each(owl.find(".bgndVideo"), function() {
            $(this).YTPlayer({containment:$(this).parent()});
          })
        }
      })
      owl.owlCarousel(config);
      owl.on('resized.owl.carousel', function(event) {
        theme.checkProductGrid_Width();
      })
      owl.on('changed.owl.carousel', function(event) {
        var itemCrr = owl.find('.owl-item').eq(event.item.index);
        owl.find('.lazyloading:not(.lazyload)').addClass('lazyload');
        $.each(owl.find('.owl-item video'), function() {
          $(this)[0].pause();
        })
        if (itemCrr.find('video').length > 0) {
          itemCrr.find('video')[0].play();
        }
        $.each(owl.find(".bgndVideo"), function() {
          $(this).YTPPause();
        })
        if (itemCrr.find('.bgndVideo').length > 0) {
          itemCrr.find('.bgndVideo').YTPPlay();
        }
      })
    });
   }
  /* ---------------------------------------------
   Owl carousel mobile
   --------------------------------------------- */
  function initCarouselMobile(){
    var window_size = jQuery('body').innerWidth();
    window_size += theme.getScrollbarWidth();
    if( window_size < 768 ){
      $('.owl-carousel-mobile').each(function(){
        $(this).addClass('owl-carousel')
        var config = $(this).data();
        var animateOut = $(this).data('animateout');
        var animateIn = $(this).data('animatein');
        var navText = $(this).data('nav-text');
        if(typeof animateOut != 'undefined' ){
          config.animateOut = animateOut;
        }
        if(typeof animateIn != 'undefined' ){
          config.animateIn = animateIn;
        }
        if(typeof (navText) == 'undefined' ){
          config.navText = ['<i class="btn btn-primary fa fa-caret-left"></i>','<i class="btn btn-primary fa fa-caret-right"></i>'];
        }
        config.navElement = 'div';
        var owl = $(this);
        owl.on('initialized.owl.carousel', function(event) {
          theme.checkProductGrid_Width();
        })
        owl.owlCarousel(config);
        owl.on('resized.owl.carousel', function(event) {
          theme.checkProductGrid_Width();
        })
      });
    }else{
      $('.owl-carousel-mobile').each(function(){
        var owl = $(this);
        owl.trigger('destroy.owl.carousel').removeClass('owl-carousel owl-loaded');
        owl.find('.owl-stage-outer').children().unwrap();
      })
    }
  }
  return{
    init: init,
    initCarouselMobile: initCarouselMobile
  };
})();

theme.carousels = {};
theme.CarouselSection = (function() {
  function Carousel(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var carousel = this.carousel = '#Carousel-' + sectionId+'.kt_home_slide .owl-carousel';
    theme.Carousel.init(container);
    theme.Carousel.initCarouselMobile(container);
  }
  return Carousel;
})();
theme.CarouselSection.prototype = _.assignIn({}, theme.CarouselSection.prototype, {
  onUnload: function() {
    delete theme.carousels[this.carousel];
  },

  onBlockSelect: function(evt) {
    var $carousel = $(this.carousel);

    // Ignore the cloned version
    var $slide = $('.slideshow__slide--' + evt.detail.blockId).parent('.owl-item:not(.cloned)');
    var clone_length = $carousel.find('.owl-item.cloned').length;
    var slideIndex = $slide.index() - (clone_length / 2 || 0);
    // Go to selected slide, pause autoplay
    $carousel.trigger('to.owl.carousel', slideIndex);
    if ($carousel[0].dataset.autoplay === 'true') {
      $carousel.trigger('stop.owl.autoplay');
    }
  },

  onBlockDeselect: function() {
    // Resume autoplay
    if ($(this.carousel)[0].dataset.autoplay === 'true') {
      $(this.carousel).trigger('play.owl.autoplay');
    }
  }
});

window.theme = theme || {};
theme.TabOwlFadeEffect = (function() {
  // effect first tab
  var sleep = 0;
  $('.tab-owl-fade-effect .nav-tab>li.active a[data-toggle="tab"]').each(function(){
    var tabElement = $(this);
    setTimeout(function() {
      tabElement.trigger('click');
    }, sleep);
    sleep += 10000
  })
  // effect click
  $(document).on('click','.tab-owl-fade-effect a[data-toggle="tab"]',function(){
    var tab_id = $(this).attr('href');
    var tab_animated = $(this).data('animated');
    tab_animated = ( tab_animated == undefined || tab_animated =="" ) ? 'fadeInUp' : tab_animated;
    $(tab_id).find('.owl-item.active').each(function(i){
      var t = $(this);
      var style = t.attr("style");
      style = ( style == undefined ) ? '' : style;
      var delay  = i * 400;
      t.attr("style", style +
             ";-webkit-animation-delay:" + delay + "ms;"
             + "-moz-animation-delay:" + delay + "ms;"
             + "-o-animation-delay:" + delay + "ms;"
             + "animation-delay:" + delay + "ms;"
            ).addClass(tab_animated+' animated').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
        t.removeClass(tab_animated+' animated');
        t.attr("style", style);
      });
    })
  })
});
  
window.theme = theme || {};
theme.TabProductFadeEffect = (function() {
  // effect first tab
  var sleep = 0;
  $('.tab-product-fade-effect .nav-tab>li.active a[data-toggle="tab"]').each(function(){
    var tabElement = $(this);
    setTimeout(function() {
      tabElement.trigger('click');
    }, sleep);
    sleep += 10000
  })
  // effect click
  $(document).on('click','.tab-product-fade-effect a[data-toggle="tab"]',function(){
    var tab_id = $(this).attr('href');
    var tab_animated = $(this).data('animated');
    tab_animated = ( tab_animated == undefined || tab_animated =="" ) ? 'fadeInUp' : tab_animated;
    $(tab_id).find('.grid-item').each(function(y){
      var t = $(this);
      var style = t.attr("style");
      style = ( style == undefined ) ? '' : style;
      var delay  = y * 400;
      t.attr("style", style +
             ";-webkit-animation-delay:" + delay + "ms;"
             + "-moz-animation-delay:" + delay + "ms;"
             + "-o-animation-delay:" + delay + "ms;"
             + "animation-delay:" + delay + "ms;"
            ).addClass(tab_animated+' animated').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
        t.removeClass(tab_animated+' animated');
        t.attr("style", style);
      });
    })
  })
});

window.theme = theme || {};
theme.ProductsMasorySection = (function() {  
  function MasonrySection(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var masonry = this.masonry = '#Masory-' + sectionId;

    KT.loadScript('isotope', function(e,l){
      if (l == 'ok') {
        var $grid = $(masonry+ '.ly__ms_items').isotope({
          itemSelector: '.grid-item',
          masonry: {
            horizontalOrder: true,
            percentPosition: true
          },
          transitionDuration: '.8s'
        });
        var imgLarge = new Image();
        imgLarge.src = $grid.find('img').first().attr('src'); 
        imgLarge.onload = function () {
          $grid.isotope('layout');      
          theme.checkProductGrid_Width();
        }
      }
    });
  }
  return MasonrySection;
})();

window.theme = theme || {};
theme.MasonrySection = (function() {  
  function MasonrySection(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var masonry = this.masonry = '#Masonry-' + sectionId;

    KT.loadScript('isotope', function(e,l){
      if (l == 'ok') {
        var $grid = $(masonry).isotope({
          itemSelector: '.masonry-item',
          masonry: {
            horizontalOrder: true,
            percentPosition: true
          },
          transitionDuration: '.8s'
        });
      }
    });
  }
  return MasonrySection;
})();

window.theme = theme || {};
theme.BannerByPage = (function() {  
  function BannerSection(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    
    // headerBannerByPage
    var headerBBP = '';
    var sectionBanner = $('div[data-section-id="'+sectionId+'"]')
    var bannerCrr = sectionBanner.attr('data-collection');
    if(headerBanner !== undefined && headerBanner !== null){
      _.forEach(headerBanner, function(block,idx0) {
        var headerBBPItem = "";
        if(block.settings.image_1 == null && block.settings.image_2 == null && block.settings.image_3 == null){
          sectionBanner.slideUp('slow');
        }
        else{
          if(block.settings.use_parallax ==  false){
          headerBBPItem += '<div class="';
          if(block.settings.width_section == true){
            headerBBPItem += 'container';
          }
          headerBBPItem += '">';
          }
          if(block.type == 'collection_banner'){
            var listHandle = block.settings.by_collections_11.split(',');
          }
          else if(block.type == 'product_banner'){
            var listHandle = block.settings.by_product_11.split(',');
          }
          else if(block.type == 'blog_banner'){
            var listHandle = block.settings.by_blog_11.split(',');
          }
          else if(block.type == 'article_banner'){
            var listHandle = block.settings.by_article_11.split(',');
          }
          else if(block.type == 'page_banner'){
            var listHandle = block.settings.by_page_11.split(',');
          }
          _.find(block.settings, function(itemCll,itemName) {
            if(page.Han == itemCll && bannerCrr !== itemCll || _.indexOf(listHandle,page.Han) >= 0 && listHandle.length > 0 && itemName.indexOf('_11') >= 0 && bannerCrr !== itemCll){
              var imgCount = 0;
              if(block.settings.image_1 != null){imgCount++}
              if(block.settings.image_2 != null){imgCount++}
              if(block.settings.image_3 != null){imgCount++}
              var data_loop = imgCount == 1 ? 'false' : 'true';
              headerBBPItem += '<div class="shop-banner position-relative" style="margin-bottom:'+block.settings.margin_bt+'px">';
              if(block.settings.use_parallax){
                // headerBBPItem += '<img class="checksize" style="opacity: 0; visibility: hidden;z-index: -11;position: absolute;left: 0 !important;" src="'+block.settings.image_1+'">';
                headerBBPItem += '<div class="parallax-section page-banner bg-parallax d-flex align-items-center justify-content-between" style="background-image: url('+block.settings.image_1+');" data-parallax-speed="0.1">';
                  headerBBPItem += '<div class="container">';
                    headerBBPItem += '<div class="row parallax_page_content align-items-center justify-content-between">';
                      headerBBPItem += '<div class="col banner-content text-center pt-5 pb-5">';
                        headerBBPItem += '<h2 class="title mt-5">'+block.settings.title_parallax+'</h2>';
                        headerBBPItem += '<p class="subtitle mb-5">'+block.settings.text_parallax+'</p>';
                      headerBBPItem += '</div>';
                    headerBBPItem += '</div>';
                  headerBBPItem += '</div>';
                headerBBPItem += '</div>';
              }
              else{
                headerBBPItem += '<div class="kt-carousel nav-center-center nav-style-default carouselLoading" data-autoplay="true" data-loop="'+data_loop+'" data-items="1" data-dots="false" data-nav="true" data-auto-height="true" data-animateout="fadeOut" data-animatein="fadeIn">';
                if(block.settings.image_1 != null){
                  headerBBPItem += '<img class="grid-view-item__image key_image lazyload" src="'+(block.settings.image_1).replace('.jpg?','_50x.jpg?')+'" data-src="'+block.settings.image_1+'" alt="">';
                }
                if(block.settings.image_2 != null){
                  headerBBPItem += '<img class="grid-view-item__image lazyload" src="'+(block.settings.image_2).replace('.jpg?','_50x.jpg?')+'" data-src="'+block.settings.image_2+'" alt="">';
                }
                if(block.settings.image_3 != null){
                  headerBBPItem += '<img class="grid-view-item__image lazyload" src="'+(block.settings.image_3).replace('.jpg?','_50x.jpg?')+'" data-src="'+block.settings.image_3+'" alt="">';
                }
                headerBBPItem += '</div>';
              }
              headerBBPItem += '</div>';
              if(sectionBanner.hasClass('default')){
                sectionBanner.removeClass('default').attr('data-collection',itemCll);
              }
              // console.log(block.settings)
            }
            else if(page.Han == itemCll && bannerCrr === itemCll || _.indexOf(listHandle,page.Han) >= 0 && listHandle.length > 0 && itemName.indexOf('_11') >= 0 && bannerCrr === itemCll){
              headerBBP = 'showing';
            }
          });
          if(block.settings.use_parallax ==  false){
          headerBBPItem += '</div>';
          }
        }
        if(headerBBPItem.indexOf('//cdn.') !== -1){
          headerBBP += headerBBPItem;
        }
      });
      if(headerBBP === 'showing'){
        sectionBanner.slideDown('slow');
        sectionBanner.find('img').css('opacity',1)
      }
      else if(headerBBP !== ''){
        var headerBBPowl = sectionBanner;
        headerBBPowl.html(headerBBP).slideDown('slow',function(){
          if(headerBBPowl.find('img').length > 1){
            headerBBPowl.find('.carouselLoading').addClass('owl-carousel');
            var config = headerBBPowl.find('.kt-carousel').data();
            if (headerBBPowl.find('.kt-carousel').hasClass('.no-overflow') && headerBBPowl.find('.kt-carousel').children().length > config.items + 2) {
              config.loop = true;
            } else {
              headerBBPowl.find('.kt-carousel').removeClass('no-overflow');
            }
            config.navText = ['<i class="btn btn-primary fa fa-caret-left"></i>','<i class="btn btn-primary fa fa-caret-right"></i>'];
            config.navElement = 'div';
            
            if (headerBBPowl.find('.kt-carousel').parent().hasClass('owl-content-fix')) {
              config.navContainer = "."+headerBBPowl.find('.kt-carousel').parent().find('.nav-fix').attr('data-nav');
            }
            var owl = headerBBPowl.find('.kt-carousel');
            headerBBPowl.find('.kt-carousel').on('initialized.owl.carousel', function(event) {
              headerBBPowl.find('.carouselLoading').removeClass('carouselLoading');
            });
            var imgLarge = new Image();
            imgLarge.src = sectionBanner.find('img.key_image').attr('src'); 
            imgLarge.onload = function () {
              KT.loadScript('owl-carousel', function(e,l){
                if (l == 'ok') {
                  owl.owlCarousel(config);
                }
              })
            }
          }
          else if(headerBBPowl.find('.bg-parallax').length > 0){
            KT.parallax();
          }
        });
        sectionBanner.addClass('default');
      }
      else{
        sectionBanner.slideUp('slow');
      }
    }
  }
  return BannerSection;
})();

window.theme = theme || {};
theme.BannerMasorySection = (function() {  
  function MasorySection(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');  

    KT.loadScript('isotope', function(e,l){
      if (l == 'ok') {
        var $grid = $('#shopify-section-'+sectionId+' .banner_masonry').isotope({
          itemSelector: '.banner--grid-item',layoutMode: 'packery',
          masonry: {
            horizontalOrder: true,
            percentPosition: true
          },
          transitionDuration: '.8s'
        });
        $grid.imagesLoaded().progress( function() {
          $grid.isotope('layout');
        });
      }
    })
  }
  function carouselBanner(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    $('#shopify-section-'+sectionId+' .owl-carousel').each(function() {
      var config = $(this).data();
      var navText = $(this).data('nav-text');
      var animateOut = $(this).data('animateout');
      var animateIn = $(this).data('animatein');
      if(typeof animateOut != 'undefined' ){
        config.animateOut = animateOut;
      }
      if(typeof animateIn != 'undefined' ){
        config.animateIn = animateIn;
      }
      if(typeof (navText) != 'undefined' ){
        config.navText = ['prev','next'];
      }
      config.lazyLoad = true;
      var owl = $(this);
      owl.on('initialized.owl.carousel', function(event) {
        $('.carouselLoading').not('.kt-carousel').removeClass('carouselLoading');
      });
      owl.owlCarousel(config);
    });
  }
  return{
    MasorySection:MasorySection,
    carouselBanner: carouselBanner
  }
})();

window.theme = theme || {};
theme.Instagram = (function() {  
  function Instagram(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var ul_ins = $('#shopify-section-'+sectionId+' .instagramWrapper'),
      dataIns = ul_ins.data();
    if("" == dataIns.accessToken) return;
    $('#instagramWrapper-'+sectionId).hide();
    KT.loadScript('instafeed', function(e,l){
      if (l == 'ok') {
        var padd = ul_ins.data('use-slide') === true ? '' : ' p-0 col-6 col-sm-4 col-md-3 col-lg-3 col-xl-2';
        var html = '';
        var count = 0;
        var feed = new Instafeed({
          target: 'instagramWrapper-'+sectionId,
          get: 'user',
          userId: dataIns.accessToken.split('.')[0],
          accessToken: dataIns.accessToken,
          sortBy: 'most-recent',
          filter: function(image) {
            var img_url_640 = image.images.standard_resolution.url;
            if (dataIns.tag !== undefined && dataIns.tag !== '') {
              if(image.tags.indexOf(dataIns.tag) >= 0 && count < dataIns.limit){
                count ++;
                html +='<li class="item position-relative'+padd+'"><a class="position-relative banner-effect1" href="' + image.link + '"><img src="' + img_url_640 + '" alt="'+image.user.full_name+'"><div class="info position-absolute text-center d-none"><span class="position-relative mr-2"><i class="fa fa-heart-o mr-1"></i>' + image.likes.count + '</span><span class="position-relative"><i class="fa fa-comments-o mr-1"></i>' + image.comments.count + '</span></div></a></li>';
              }
            } else if (count < dataIns.limit){
              count ++;
              html +='<li class="item position-relative'+padd+'"><a class="position-relative banner-effect1" href="' + image.link + '"><img src="' + img_url_640 + '" alt="'+image.user.full_name+'"><div class="info position-absolute text-center d-none"><span class="position-relative mr-2"><i class="fa fa-heart-o mr-1"></i>' + image.likes.count + '</span><span class="position-relative"><i class="fa fa-comments-o mr-1"></i>' + image.comments.count + '</span></div></a></li>';
            }
            if(count >= dataIns.limit){
              return false;
            }
          },
          error: function(data) {
            console.log('ajax error');
          },
          after: function() {
            $('#instagramWrapper-'+sectionId).html(html).show(0);
            ul_ins.find('li:empty').remove();
            if(dataIns.useSlide === true || dataIns.useSlide === 'true' ){
              var $this = ul_ins;
              var config = $this.data();
              if ($this.hasClass('.no-overflow') && $this.children().length > config.items + 2) {
                config.loop = true;
              } else {
                $this.removeClass('no-overflow');
              }
              config.navText = ['<i class="btn btn-primary fa fa-caret-left"></i>','<i class="btn btn-primary fa fa-caret-right"></i>'];
              config.navElement = 'div';
              
              if ($this.parent().hasClass('owl-content-fix')) {
                config.navContainer = "."+$this.parent().find('.nav-fix').attr('data-nav');
              }
              var owl = $this;
              KT.loadScript('owl-carousel', function(e,l){
                if (l == 'ok') {
                  owl.owlCarousel(config);
                  owl.on('resized.owl.carousel', function(event) {
                    theme.checkProductGrid_Width();
                  })
                }
              })
            }
          }
        });
        feed.run();
      }
    })
  }
  return Instagram;
})();

window.theme = theme || {};
theme.stockCountdown = (function(){
  // Settings are here
  var total_items = 70;
  var check_stock = false;
  var timer = null,timerinterval = null;
  var min_of_remaining_items = 1;
  var decrease_after = 1.7; 
  var decrease_after_first_item = 0.17; 
  var min_items_left = 0;
  var max_items_left = 0;
  var remaining_items = 0;
  var stock_bg_process = 0;
  function randomIntFromInterval(min, max) {return Math.floor(Math.random() * (max - min + 1) + min);}
  function progressbar(container) {
    updateMeter(container);
    timer = setTimeout(function() {
      updateMeter(container)
    }, 1000 * 60 * decrease_after_first_item );

    timerinterval = setInterval(function() {
      updateMeter(container)
    }, 1000 * 60 * decrease_after)
  }
  function updateMeter(container,remaining_items_) {
    var remaining_items_ = remaining_items_;
    if (remaining_items_ == undefined) {
      remaining_items_ = remaining_items--;
      if (remaining_items < min_of_remaining_items) {
        remaining_items = remaining_items_;
        remaining_items_ = randomIntFromInterval(min_items_left, max_items_left)
      }
    }
    var content = theme.productStrings.stockMessage[0]+' <span class="count">' + remaining_items_ + '</span> '+theme.productStrings.stockMessage[1];
    $(container).addClass('items-count').find('p').html(content);
    $(container).find('kt_progress_bar_pr .count').css('background-color', stock_bg_process);
    $(container).find('kt_progress_bar_pr .count').css('color', '#fff');
    setTimeout(function() {
      $(container).find('kt_progress_bar_pr .count').css('background-color', '#fff');
      $(container).find('kt_progress_bar_pr .count').css('color', stock_bg_process)
    }, 1000 * 60 * 0.03);
    $(container).find(".count").text(remaining_items_);
    $(container).closest('.product-inner').find('.show-iq span,#quantity_sticky span').text(remaining_items_);
    var width = 100 * remaining_items_ / total_items;
    if (remaining_items_ < 10) {
      $(container).find('.progress').addClass('less-than-ten')
    }
    setTimeout(function() {
      $(container).find('.progress-bar').css('width', width + '%').attr('aria-valuenow', width);;
    },300);
    max_items_left = remaining_items_;
  }
  function init(container){
    if($(container).length <= 0){return false} 
    min_items_left = parseInt($(container).attr('data-stock-from'));
    max_items_left = parseInt($(container).attr('data-stock-to'));
    remaining_items = parseInt($(container).attr('data-remaining_items')) || randomIntFromInterval(min_items_left, max_items_left);
    stock_bg_process = $(container).attr('data-stock-bg-process');
    progressbar(container);
  }
  return {
    init: init,
    progressbar: progressbar,
    updateMeter: updateMeter
  };
})();

theme.ktCountdown = (function(container){ 
  var container_ = container !== undefined ? '#'+$(container).attr('id')+' ' : '';
  if($(container_+'.kt_countdow').length >0){
    KT.loadScript('countdown', function(e,l){
      if (l == 'ok') {
        init();
      }
    });
    function init(){
      $(container_+'.kt_countdow').each(function() {
        var $this = $(this);
        if ($this.hasClass('kt_loop_bar')) {
          var sFullDay = 86400,
             hours = parseInt($this.data('h')),
             minutes = parseInt($this.data('i')),
             seconds = parseInt($this.data('s')),
             seconds_row = hours*60*60+minutes*60+seconds,
             // d = moment($this.data('time-now')),
             date = $this.data('time-now'),
             loop_per_day = Math.ceil(sFullDay/seconds_row);
          // many days from now!
          var secondsTimeSpanToHMS = function(seconds) {
            var s = seconds;
            var h = Math.floor(s/3600);
            s -= h*3600;
            var m = Math.floor(s/60);
            s -= m*60;
            return (h < 10 ? '0'+h : h)+":"+(m < 10 ? '0'+m : m)+":"+(s < 10 ? '0'+s : s);
          }
          var checkRow = function checkRow() {
            for (var i = 1; i < loop_per_day + 1; i++) {
              var now_h = parseInt($this.data('h-now'));
              var now_m = parseInt($this.data('i-now'));
              var now_s = parseInt($this.data('s-now'));
              var now = now_h*60*60+now_m*60+now_s;
              if (now < seconds_row * i) {
                return seconds_row * i < sFullDay ? seconds_row * i : sFullDay;
              }
            }
          }
          if(checkRow() !== undefined || checkRow() !== null){
            var seconds_end = secondsTimeSpanToHMS(checkRow());
            $this.countdown(Date.parse(date+' '+seconds_end + ' ' + $this.data('time-zone')), {elapse: true})
            .on('update.countdown', function(event) {
              var $this = $(this);
              if (event.elapsed) {
                $this.html('');
              } else {
                $this.html(event.strftime(''
                  + '<div class="block"><span class="flip-top">%H</span><span class="label">'+theme.strings.cdhrs+'</span></div>'
                  + '<div class="block"><span class="flip-top">%M</span><span class="label">'+theme.strings.cdmin+'</span></div>'
                  + '<div class="block"><span class="flip-top">%S</span><span class="label">'+theme.strings.cdsecs+'</span></div>'));
              }
            });
          }
        }
        else{

          // var endTime = moment.tz($(this).data('time'), $(this).data('time-zone'));
          $this.countdown(Date.parse($this.data('time')), {elapse: true})
          .on('update.countdown', function(event) {
            var $this = $(this);
            if (event.elapsed) {
              $this.html('');
            } else {
              $this.html(event.strftime(''
                + '<div class="block"><span class="flip-top">%-D</span><span class="label">'+theme.strings.cdday+'</span></div>'
                + '<div class="block"><span class="flip-top">%H</span><span class="label">'+theme.strings.cdhrs+'</span></div>'
                + '<div class="block"><span class="flip-top">%M</span><span class="label">'+theme.strings.cdmin+'</span></div>'
                + '<div class="block"><span class="flip-top">%S</span><span class="label">'+theme.strings.cdsecs+'</span></div>'));
            }
          });
        }
      });
    }    
  }
})

theme.dateFromTo = (function(container){
  var container_ = container !== undefined ? '#'+$(container).attr('id')+' ' : '';
  if ($(container_).find('.product_delivery').length >0) {
    var el = $(container_).find('.product_delivery');
    var data = el.data();
    var fromDays = parseInt(data.fromDate);
    var toDays = parseInt(data.toDate);
    KT.loadScript('moment', function(e,l){
      if (l == 'ok') {
        var fromDate = moment().add(fromDays, 'days');
        if (data.offSaturday && fromDate.format('dddd') == 'Saturday'){
          fromDays++;
          fromDate = moment().add(fromDays, 'days');
        }
        if (data.offSunday &&fromDate.format('dddd') == 'Sunday') { 
          fromDays = fromDays + 2;
          fromDate = moment().add(fromDays, 'days');
        }
        if (toDays > fromDays) {
          var toDate = moment().add(toDays, 'days');
          if (data.offSaturday &&toDate.format('dddd') == 'Saturday'){
            toDays++;
            toDate = moment().add(toDays, 'days');
          }
          if (data.offSunday &&toDate.format('dddd') == 'Sunday') {
            toDays = toDays + 2;
            toDate = moment().add(toDays, 'days');
          }
        }

        $.each(data.offDays, function(index, val) {
          var valD = val.split('/')[1],valM = val.split('/')[0],valY = val.split('/')[2];
          if (fromDate.format('DD') === valD && fromDate.format('MM') === valM) {
            if (fromDate.format('YYYY') === '****' || fromDate.format('YYYY') === valY) {
              fromDays++;
              fromDate = moment().add(fromDays, 'days');
            }
          }
          if (toDays > fromDays) {
            if (toDate.format('DD') === valD && toDate.format('MM') === valM) {
              if (toDate.format('YYYY') === '****' || toDate.format('YYYY') === valY) {
                toDays++;
                toDate = moment().add(toDays, 'days');
              }
            }
          }
        });
        el.find('#fromDate').html(fromDate.format('dddd MM/DD/YYYY'));
        if (toDays > fromDays) {
          el.find('#toDate').html(toDate.format('dddd MM/DD/YYYY'));
          el.find('.toDate').removeClass('d-none');
        }
      }
    })
  }
})

theme.realTimeVisitor = (function(container){
  var container_ = container !== undefined ? '#'+$(container).attr('id')+' ' : '';
  if ($(container_).find('.realTime').length >0) {
    var el = $(container_).find('.realTime');
    $(function(a){
      var min = 1,
      max = el.find('.counter_real_time').attr('data-counter-max'),
      t=1,
      r=max;
      t=Math.ceil(t),
      r=Math.floor(r);
      var o=Math.floor(Math.random()*(r-t+1))+t,
      n=["1","2","4","3","6","10","-1","-3","-2","-4","-6"],
      h="",e="",l=["10","20","15"],h="",e="",M="";
      setInterval(function(){
        if(h=Math.floor(Math.random()*n.length),e=n[h],o=parseInt(o)+parseInt(e),min>=o){
          M=Math.floor(Math.random()*l.length);
          var a=l[M];o+=a
        }
        if(o<1 || o>max ){
          o=Math.floor(Math.random()*(r-t+1))+t;
        }
        el.find("#number_counter>span").html((parseInt(o)));el.show();
      },parseInt(el.find('.counter_real_time').attr('data-interval-time')))
    });
  }
})

window.theme = theme || {};
theme.BannerSection = (function() {
  function Banner(container) {
    theme.ktCountdown(container);
    if ($(container).find('.owl-carousel').length > 0) {
      KT.loadScript('owl-carousel', function(e,l){
        if (l == 'ok') {
          theme.Carousel.init(container);
        }
      })
    }
  }
  return Banner;
})();

theme.variantChange = (function(){
  function vars_change(vrId,chageByTitle,opt,prVrs,el) {
    var element = el;
    var el = el[0].nodeName === "SELECT" ? '' : el;
    var formJs = element;
    if (el !== '' && $('#qvShowUp #ProductSection'+el.attr('.data-section-id')).length > 0) {
      formJs = $('#qvShowUp #ProductSection'+el.attr('.data-section-id'));
    }
    if (el !== '' && $('#amShowUpJSON').length > 0) {
      formJs = $('#amShowUpJSON');
    }
    var img_url = '';
    var activeVr = _.find(prVrs, { 'id': vrId});
    activeVr = _.find(prVrs, { 'title': chageByTitle}) || activeVr;
    if (opt === 'Opt1Js') {
      var varsVisible = _.filter(prVrs, { 'option1': activeVr.option1 });
      if (activeVr.option2) {
        var vars_opt2 = '', vars_unless2 = new Array, selected2 = '';
        var vars_opt3 = '', vars_unless3 = new Array, selected3 = '';
        _.forEach(varsVisible, function(variant) {
          if (_.indexOf(vars_unless2,variant.option2) == -1 && activeVr.option1 == variant.option1) {
            vars_unless2.push(variant.option2)
            if (el !== '') {
              var active = activeVr.id == variant.id ? ' active': '';
              var maybeHide2 = vars_unless2.length > 5 ? true : false;
              vars_opt2 += '<li class="swatch-on-grid _'+ _handleize(variant.option2) + active +'" data-toggle="tooltip" data-placement="top" title="'+ variant.option2 +'" data-available="'+ variant.available +'" data-maybe-hide="'+maybeHide2+'">';
              vars_opt2 += '<span class="swatch" data-vrS="kt_'+ _handleize(variant.option2) +'" data-opt="Opt2Js" data-vrId='+ variant.id +' data-available="'+ variant.available +'" title="'+ variant.title.replace('"','&quot;')+'">';
              vars_opt2 += '<span class="swatch-title">'+ variant.option2 +'</span><span class="comma">,</span>';
              vars_opt2 += '</span></li>';
            } else {
              var selected = activeVr.id == variant.id ? ' selected' : '';
              if (activeVr.id == variant.id) {selected2 = variant.option2}
              vars_opt2 += '<option'+selected+' class="swatch _'+ _handleize(variant.option2) +'" data-available="'+ variant.available +'" value="'+ variant.option2.replace('"','&quot;') +'" data-opt="Opt2Js" data-vrId="'+ variant.id +'">';
              vars_opt2 += variant.option2;
              vars_opt2 += '</option>';
            }
          }
          if (activeVr.option3) {
            if (activeVr.id == variant.id) {
              vars_unless3.push(variant.option3);
              if (el !== '') {
                var maybeHide3 = vars_unless3.length > 5 ? true : false;
                vars_opt3 += '<li class="swatch-on-grid _'+ _handleize(variant.option3) +' active" data-toggle="tooltip" data-placement="top" title="'+ variant.option3 +'" data-available="'+ variant.available +'" data-maybe-hide="'+maybeHide3+'">';
                vars_opt3 += '<span class="swatch" data-vrS="kt_'+ _handleize(variant.option3) +'" data-opt="Opt3Js" data-vrId='+ variant.id +' data-available="'+ variant.available +'" title="'+ variant.title.replace('"','&quot;')+'">';
                vars_opt3 += '<span class="swatch-title">'+ variant.option3 +'</span><span class="comma">,</span>';
                vars_opt3 += '</span></li>';
              } else {
                selected3 = variant.option3
                vars_opt3 += '<option selected class="swatch _'+ _handleize(variant.option3) +'" data-available="'+ variant.available +'" value="'+ variant.option3.replace('"','&quot;') +'" data-opt="Opt3Js" data-vrId="'+ variant.id +'">';
                vars_opt3 += variant.option3;
                vars_opt3 += '</option>';
              }
            }
            if (_.indexOf(vars_unless3,variant.option3) == -1 && activeVr.option1 === variant.option1 && activeVr.option2 === variant.option2 && activeVr.option3 !== variant.option3) {
              vars_unless3.push(variant.option3);
              if (el !== '') {
                var maybeHide3 = vars_unless3.length > 5 ? true : false;
                vars_opt3 += '<li class="swatch-on-grid _'+ _handleize(variant.option3) +'" data-toggle="tooltip" data-placement="top" title="'+ variant.option3 +'" data-available="'+ variant.available +'" data-maybe-hide="'+maybeHide3+'">';
                vars_opt3 += '<span class="swatch" data-vrS="kt_'+ _handleize(variant.option3) +'" data-opt="Opt3Js" data-vrId='+ variant.id +' data-available="'+ variant.available +'" title="'+ variant.title.replace('"','&quot;')+'">';
                vars_opt3 += '<span class="swatch-title">'+ variant.option3 +'</span><span class="comma">,</span>';
                vars_opt3 += '</span></li>';                
              } else {
                vars_opt3 += '<option class="swatch _'+ _handleize(variant.option3) +'" data-available="'+ variant.available +'" value="'+ variant.option3.replace('"','&quot;') +'" data-opt="Opt3Js" data-vrId="'+ variant.id +'">';
                vars_opt3 += variant.option3;
                vars_opt3 += '</option>';
              }
            }
          }
          if (variant.option1 == activeVr.option1 && variant.featured_image){
            img_url = variant.featured_image.src;
          }
        });
        if (el !== '') {
          if(vars_unless2.length > 5){
            vars_opt2 += '<li class="swatch-on-grid more kt__quick-shop"><span class="swatch"><span class="swatch-title">'+theme.productStrings.viewMoreVariants+'+</span></span> </li>';
          }
          if(vars_unless3.length > 5){
            vars_opt3 += '<li class="swatch-on-grid more kt__quick-shop"><span class="swatch"><span class="swatch-title">'+theme.productStrings.viewMoreVariants+'+</span></span> </li>';
          }
          formJs.closest('.product-inner').find('[data-opt="Opt2Js"] .content__variants_list').html(vars_opt2);
          formJs.closest('.product-inner').find('[data-opt="Opt3Js"] .content__variants_list').html(vars_opt3);
        } else {
          element.closest('tr').find('select[data-opt="Opt2Js"]').html(vars_opt2).val(selected2);
          element.closest('tr').find('select[data-opt="Opt3Js"]').html(vars_opt3).val(selected3);
        }
      }
    }
    if (opt === 'Opt2Js') {
      var varsVisible = _.filter(prVrs, { 'option1': activeVr.option1 });
      if (parseInt(formJs.data('options')) == 3) {
        var vars_opt3 = '', vars_unless3 = new Array;
        _.forEach(varsVisible, function(variant) {
          if (activeVr.id == variant.id) {
            vars_unless3.push(variant.option3);
            if (el !== '') {
              var maybeHide3 = vars_unless3.length > 5 ? true : false;
              vars_opt3 += '<li class="swatch-on-grid _'+ _handleize(variant.option3) +' active" data-toggle="tooltip" data-placement="top" title="'+ variant.option3 +'" data-available="'+ variant.available +'" data-maybe-hide="'+maybeHide3+'">';
              vars_opt3 += '<span class="swatch" data-vrS="kt_'+ _handleize(variant.option3) +'" data-opt="Opt3Js" data-vrId='+ variant.id +' data-available="'+ variant.available +'" title="'+ variant.title.replace('"','&quot;')+'">';
              vars_opt3 += '<span class="swatch-title">'+ variant.option3 +'</span><span class="comma">,</span>';
              vars_opt3 += '</span></li>';
            } else {
              if (activeVr.id == variant.id) {selected3 = variant.option3}
              vars_opt3 += '<option selected class="swatch _'+ _handleize(variant.option3) +'" data-available="'+ variant.available +'" value="'+ variant.option3.replace('"','&quot;') +'" data-opt="Opt3Js" data-vrId="'+ variant.id +'">';
              vars_opt3 += variant.option3;
              vars_opt3 += '</option>';
            }
          }
          if (_.indexOf(vars_unless3,variant.option3) === -1 && activeVr.option1 === variant.option1 && activeVr.option2 === variant.option2) {
            vars_unless3.push(variant.option3);
            if (el !== '') {
              var maybeHide3 = vars_unless3.length > 5 ? true : false;
              vars_opt3 += '<li class="swatch-on-grid _'+ _handleize(variant.option3) +'" data-toggle="tooltip" data-placement="top" title="'+ variant.option3 +'" data-available="'+ variant.available +'" data-maybe-hide="'+maybeHide3+'">';
              vars_opt3 += '<span class="swatch" data-vrS="kt_'+ _handleize(variant.option3) +'" data-opt="Opt3Js" data-vrId='+ variant.id +' data-available="'+ variant.available +'" title="'+ variant.title.replace('"','&quot;')+'">';
              vars_opt3 += '<span class="swatch-title">'+ variant.option3 +'</span><span class="comma">,</span>';
              vars_opt3 += '</span></li>';
            } else {
              if (activeVr.id == variant.id) {selected3 = variant.option3}
              vars_opt3 += '<option class="swatch _'+ _handleize(variant.option3) +'" data-available="'+ variant.available +'" value="'+ variant.option3.replace('"','&quot;') +'" data-opt="Opt3Js" data-vrId="'+ variant.id +'">';
              vars_opt3 += variant.option3;
              vars_opt3 += '</option>';
            }
          }
          if (variant.option1 == activeVr.option1 && variant.featured_image){
            img_url = variant.featured_image.src;
          }
        });
        if (el !== '') {
          if(vars_unless3.length > 5){
            vars_opt3 += '<li class="swatch-on-grid more kt__quick-shop"><span class="swatch"><span class="swatch-title">'+theme.productStrings.viewMoreVariants+'+</span></span> </li>';
          }
          formJs.closest('.product-inner').find('[data-opt="Opt3Js"] .content__variants_list').html(vars_opt3);
        } else {
          element.closest('tr').find('select[data-opt="Opt3Js"]').html(vars_opt3).val(selected3);
        }
      }
    }
    if (el !== '') {
      var pInner = formJs.closest('.product-inner');
      var name_src = pInner.find('.primary-thumb img').attr('src') != undefined ? pInner.find('.primary-thumb img').attr('src').split(',')[0] : undefined;
      var name_srcset = pInner.find('.primary-thumb img').attr('srcset') != undefined ? pInner.find('.primary-thumb img').attr('srcset').split(',')[0] : undefined;
      var imgChecked = false;
      if (activeVr.featured_image && name_src != undefined) {
        imgChecked = (name_src.split('/').slice(-1)[0]).indexOf(theme.Images.getName(activeVr.featured_image.src)) >= 0 || (name_src.split('/').slice(-1)[0]).indexOf(theme.Images.getName(activeVr.featured_image.src)) === -1 ? true : false;
      }
      if (activeVr.featured_image && name_srcset != undefined) {
        imgChecked = (name_srcset.split('/').slice(-1)[0]).indexOf(theme.Images.getName(activeVr.featured_image.src)) >= 0 || (name_srcset.split('/').slice(-1)[0]).indexOf(theme.Images.getName(activeVr.featured_image.src)) === -1 ? true : false;
      }
      if (imgChecked === true) {
        var img_url = activeVr.featured_image.src;
        var fileExt = _.last(img_url.split('.'));
        var imgLarge = new Image();
        imgLarge.src = theme.Images.removeProtocol(img_url.replace('.'+fileExt, '_540x.'+fileExt)); 
        imgLarge.onload = function () {
          var featured_image = '<div class="primary-thumb '+theme.Images.imgFit(activeVr.featured_image.width,activeVr.featured_image.height)+'"><img class="lazyload"';
              featured_image += 'src="'+theme.Images.removeProtocol(imgLarge.src)+'"';
              featured_image += 'data-src="'+theme.Images.removeProtocol(img_url.replace('.'+fileExt, '_{width}x.'+fileExt))+'"';
              featured_image += 'data-widths="[360, 540, 720, 900, 1080]"';
              featured_image += 'data-sizes="auto"';
              featured_image += 'alt=""></div>';
          pInner.find('.aspectRatio').append(featured_image);
          pInner.find('.primary-thumb').first().remove();
          pInner.find('.second-thumb').first().remove();
          pInner.find('.product_type_variable').removeClass('loading');
        }
      }
      else{
        pInner.find('.product_type_variable').removeClass('loading');
      }
      pInner.find('[class*="ProductVaries-"]').addClass('d-none');
      pInner.find('[class*="ProductPrice-"]').html(theme.Currency.formatMoney(activeVr.price, theme.moneyFormat)).removeClass('d-none');
      if (activeVr.compare_at_price > activeVr.price) {
        pInner.find('[class*="ComparePrice-"]').removeClass('d-none');
        pInner.find('[class*="ComparePrice-"]').html(theme.Currency.formatMoney(activeVr.compare_at_price, theme.moneyFormat));
      }
      else{
        pInner.find('[class*="ComparePrice-"]').addClass('d-none');
      }
      pInner.find('input[name="id"]').val(activeVr.id);
      pInner.find('.add_to_cart_button').attr('data-vrid', activeVr.id);
      if(theme.function.multiCurrency == true && cookieCurrency !== null && cookieCurrency !== shopCurrency){
        Currency.convertAll(shopCurrency,cookieCurrency,'span.money');
      }
      if (activeVr.available || activeVr.available && activeVr.inventory_quantity <= 0 && activeVr.inventory_policy != 'deny') {
        pInner.find('.add_to_cart_button').prop('disabled', false);        
        pInner.find('.add_to_cart_button').attr('onclick', pInner.find('.add_to_cart_button').attr('data-onclick')).removeAttr('data-onclick');
        if (activeVr.inventory_quantity <= 0 && activeVr.inventory_policy != 'deny'){
          pInner.find('.add_to_cart_button').text(theme.strings.preOrder);
        }else{
          pInner.find('.add_to_cart_button').text(theme.strings.addToCart);
        }
      } else {
        pInner.find('.add_to_cart_button').prop('disabled', true);
        pInner.find('.add_to_cart_button').text(theme.strings.soldOut).attr('data-onclick', pInner.find('.add_to_cart_button').attr('onclick')).removeAttr('onclick');

      }
    }
    else {
      var name_src = element.closest('tr').find('.vr-img img').attr('src').split(',')[0];
      var imgChecked = false;
      if (name_src != undefined && activeVr.featured_image) {
        imgChecked = (name_src.split('/').slice(-1)[0]).indexOf(theme.Images.getName(activeVr.featured_image.src)) >= 0 || (name_src.split('/').slice(-1)[0]).indexOf(theme.Images.getName(activeVr.featured_image.src)) === -1 ? true : false;
      }
      if (imgChecked === true) {
        img_url = activeVr.featured_image.src;
        var fileExt = _.last(img_url.split('.'));
        var imgLarge = new Image();
        imgLarge.src = img_url.replace('.'+fileExt, '_180x180_crop_center.'+fileExt); 
        imgLarge.onload = function () {
          var featured_image = '<img src="'+theme.Images.removeProtocol(img_url.replace('.'+fileExt, '_180x180_crop_center.'+fileExt))+'"></div>';
          element.closest('tr').find('.vr-img').append(featured_image);
          element.closest('tr').find('.vr-img img').first().remove();
          element.closest('#amShowUp').find('.add_to_cart_button').removeClass('loading');
        }
      }else{
        element.closest('#amShowUp').find('.add_to_cart_button').removeClass('loading');
      }
      element.closest('tr').find('[class*="ProductPrice-"]').html(theme.Currency.formatMoney(activeVr.price, theme.moneyFormat));
      if (activeVr.compare_at_price > activeVr.price) {
        element.closest('tr').find('[class*="ComparePrice-"]').show();
        element.closest('tr').find('[class*="ComparePrice-"]').html(theme.Currency.formatMoney(activeVr.compare_at_price, theme.moneyFormat));
      }
      else{
        element.closest('tr').find('[class*="ComparePrice-"]').hide();
      }
      element.closest('tr').find('input[name="quantity"]').attr('data-id',activeVr.id);
      if (activeVr.available) {
        element.closest('tr').find('input[name="quantity"]').removeAttr('max').attr('min', 1).val(1);
      } else {
        element.closest('tr').find('input[name="quantity"]').attr({'min': 0,'max': 0}).val(0);
      }
      element.closest('tr').find('.vr-title span').text(activeVr.title);
      element.closest('#amShowUp').find('.btn-addmore').attr('data-vrid',activeVr.id);
      if(theme.function.multiCurrency == true && cookieCurrency !== null && cookieCurrency !== shopCurrency){
        Currency.convertAll(shopCurrency,cookieCurrency,'#amShowUp span.money');
      }
    }
    if (formJs.parents('.kt-stickyAddCart').length > 0) {
      var productSingleObject = JSON.parse(document.getElementById('ProductJson-product-template').innerHTML);
      var option1 = $('#SingleOptionSelector-0--product-template').val();
      var option1_cr = _handleize(option1);
      var options_title = activeVr.title.split(' / ');
      $('#ProductSection-product-template .fake_select li').removeClass('selected');
      $(activeVr.options).each(function(index, option) {
        var option_title = option;
        var option = _handleize(option);
        var options_change = $("#ProductSection-product-template option[value='"+option_title+"']").val();
        var $options_change_ = $("#ProductSection-product-template option[value='"+option_title+"']").parent();
        $('#ProductSection-product-template .fake_select li._'+option).addClass('selected');
        $('label[data-change-label="SingleOptionSelector-'+index+'--product-template"] .text').text(option_title);
        if(options_change != $options_change_.val()){
          $options_change_.val(options_change).change();
        }
      });
    }
  }
  $(document).on('click','.product-loop-variants .swatch-on-grid:not(.more) .swatch', function(event){
    var url = $(this).attr('data-view');
    var $this = $(this);
    var formJs = $this.closest('.product-inner').find('form[data-section-id]').last();
    formJs.closest('.product-inner').find('.product_type_variable').addClass('loading');
    formJs.closest('.product-inner').find('[data-opt="'+$this.data('opt')+'"] .variants_list li.active').removeClass('active');
    $this.parent().addClass('active');
    var activeVrOpt1 = formJs.closest('.product-inner').find('[data-opt="Opt1Js"] .variants_list li.active').attr('title');
    var activeVrOpt2 = formJs.closest('.product-inner').find('[data-opt="Opt2Js"] .variants_list li.active').attr('title');
    var activeVrOpt3 = formJs.closest('.product-inner').find('[data-opt="Opt3Js"] .variants_list li.active').attr('title');
    var varTitle = activeVrOpt1 + (activeVrOpt2 !== undefined ? ' / '+ activeVrOpt2 : '') + (activeVrOpt3 !== undefined ? ' / '+ activeVrOpt3 : '');
    if (formJs.attr('data-pr-vrs') == '') {
      $.ajax({
        url: url+'?view=vrsjson',
        type: 'GET'
      })
      .done(function(data) {
        // console.log("success");
        formJs.attr('data-pr-vrs', data.replace('<!-- BEGIN template --><!-- product.vrsjson -->','').replace('<!-- END template -->',''));
        vars_change($this.data('vrid'),varTitle,$this.data('opt'),JSON.parse(data.replace('<!-- BEGIN template --><!-- product.vrsjson -->','').replace('<!-- END template -->','')),formJs);
      })
      .fail(function() {
        // console.log("error");
      })
      .always(function() {
        // console.log("complete");
      });
    } else {
      vars_change($this.data('vrid'),varTitle,$this.attr('data-opt'),JSON.parse(formJs.attr('data-pr-vrs')),formJs);
    }
  });
  $(document).on('change','select.product-loop-variants', function(event){
    var url = $(this).attr('data-view');
    var $this = $(this);
    var formJs = $('#amShowUpJSON');
    $('#amShowUp').find('.add_to_cart_button').addClass('loading');
    var activeVrOpt1 = $this.closest('tr').find('select[data-opt="Opt1Js"]').val();
    var activeVrOpt2 = $this.closest('tr').find('select[data-opt="Opt2Js"]').val();
    var activeVrOpt3 = $this.closest('tr').find('select[data-opt="Opt3Js"]').val();
    if ($(this).val().indexOf('"') > 0) {
      $(this).find("option:not([value='"+$(this).val()+"'])").removeAttr('selected');
      $(this).find("option[value='"+$(this).val()+"']").attr('selected', 'selected');
    } else {
      $(this).find('option:not([value="'+$(this).val()+'"])').removeAttr('selected');
      $(this).find('option[value="'+$(this).val()+'"]').attr('selected', 'selected');
    }
    var varTitle = activeVrOpt1 + (activeVrOpt2 !== undefined ? ' / '+ activeVrOpt2 : '') + (activeVrOpt3 !== undefined ? ' / '+ activeVrOpt3 : '');
    vars_change($(this).find('option:selected').data('vrid'),varTitle,$(this).find('option:selected').data('opt'),formJs.data('pr-vrs'),$(this))
  });
});

window.theme = theme || {};
theme.variantsAddMore = (function(){
  function buildSelect(prVrs,vrId) {
    var activeVr = _.find(prVrs, { 'id': vrId});
    if (activeVr.option1) {
      var varsVisible = _.filter(prVrs, { 'option1': activeVr.option1 });
      var vars_opt1 = '', vars_unless1 = new Array;
      var vars_opt2 = '', vars_unless2 = new Array;
      var vars_opt3 = '', vars_unless3 = new Array;
      var img_url = '';
      _.forEach(prVrs, function(variant) {
        if (_.indexOf(vars_unless1,variant.option1) == -1) {
          if (activeVr.id == variant.id) {
            vars_unless1.push(variant.option1);
            vars_opt1 += '<option selected class="swatch _'+ _handleize(variant.option1) +'" data-available="'+ variant.available +'" value="'+ variant.option1.replace('"','&quot;') +'" data-opt="Opt1Js" data-vrId="'+ variant.id +'">';
            vars_opt1 += variant.option1;
            vars_opt1 += '</option>';
          }
          if (_.indexOf(vars_unless1,variant.option1) == -1 && activeVr.option1 !== variant.option1) {
            vars_unless1.push(variant.option1);
            vars_opt1 += '<option class="swatch _'+ _handleize(variant.option1) +'" data-available="'+ variant.available +'" value="'+ variant.option1.replace('"','&quot;') +'" data-opt="Opt1Js" data-vrId="'+ variant.id +'">';
            vars_opt1 += variant.option1;
            vars_opt1 += '</option>';
          }
        }
      });
      _.forEach(varsVisible, function(variant) {
        if (variant.option1 == activeVr.option1 && variant.featured_image){
          img_url = variant.featured_image.src;
        }
        if (activeVr.option2){
          if (activeVr.id == variant.id) {
            vars_unless2.push(variant.option2);
            vars_opt2+= '<option selected class="swatch _'+ _handleize(variant.option2) +'" data-available="'+ variant.available +'" value="'+ variant.option2.replace('"','&quot;') +'" data-opt="Opt2Js" data-vrId="'+ variant.id +'">';
            vars_opt2 += variant.option2;
            vars_opt2 += '</option>';
          }
          if(_.indexOf(vars_unless2,variant.option2) == -1 && activeVr.option1 == variant.option1 && activeVr.option2 !== variant.option2) {
            vars_unless2.push(variant.option2);
            vars_opt2 += '<option class="swatch _'+ _handleize(variant.option2) +'" data-available="'+ variant.available +'" value="'+ variant.option2.replace('"','&quot;') +'" data-opt="Opt2Js" data-vrId="'+ variant.id +'">';
            vars_opt2 += variant.option2;
            vars_opt2 += '</option>';
          }
        } 
        if (activeVr.option3) {
          if (activeVr.id == variant.id) {
            vars_unless3.push(variant.option3);
            vars_opt3 += '<option selected class="swatch _'+ _handleize(variant.option3) +'" data-available="'+ variant.available +'" value="'+ variant.option3.replace('"','&quot;') +'" data-opt="Opt3Js" data-vrId="'+ variant.id +'">';
            vars_opt3 += variant.option3;
            vars_opt3 += '</option>';
          }
          if (_.indexOf(vars_unless3,variant.option3) == -1 && activeVr.option1 === variant.option1 && activeVr.option2 === variant.option2 && activeVr.option3 !== variant.option3) {
            vars_unless3.push(variant.option3);
            vars_opt3 += '<option class="swatch _'+ _handleize(variant.option3) +'" data-available="'+ variant.available +'" value="'+ variant.option3.replace('"','&quot;') +'" data-opt="Opt3Js" data-vrId="'+ variant.id +'">';
            vars_opt3 += variant.option3;
            vars_opt3 += '</option>';
          }
        }
      });
      var html = '';
      html += '<tr>';
        html += '<th class="delete-wrapper text-center" scope="row"><i class="fa fa-trash-o btn-delete" aria-hidden="true" onclick="$(this).closest(\'tr\').remove()"></i></th>';
        html += '<td class="hide-lg text-left"><div class="vr-img">';
        if (activeVr.featured_image){
          img_url = activeVr.featured_image.src;
          var fileExt = _.last(img_url.split('.'));
          html += '<img src="'+ theme.Images.removeProtocol(img_url.replace('.'+fileExt, '_180x180_crop_center.'+fileExt)) +'">'; 
        } else if (img_url !== '') {
          var fileExt = _.last(img_url.split('.'));
          html += '<img src="'+ theme.Images.removeProtocol(img_url.replace('.'+fileExt, '_180x180_crop_center.'+fileExt)) +'">'; 
        } else if ($('#amShowUp').attr('data-featured-image') !== ''){
          img_url = $('#amShowUpJSON').attr('data-featured-image');
          var fileExt = _.last(img_url.split('.'));
          html += '<img src="'+ theme.Images.removeProtocol(img_url.replace('.'+fileExt, '_180x180_crop_center.'+fileExt)) +'">'; 
        }
        html += '</div><div class="vr-title"><span>'+activeVr.title+'</span><i class="fa fa-pencil-square-o change-d" aria-hidden="true"></i></div></td>';
          html += '<td class="hide-sm" class="hide-lg" data-title="'+$('#amShowUp th').eq(1).text()+'"><select class="product-loop-variants" data-opt="Opt1Js">'+vars_opt1+'</select></td>';
        if (vars_opt2 !== '') {
          html += '<td class="hide-sm" data-title="'+$('#amShowUp th').eq(2).text()+'"><select class="product-loop-variants" data-opt="Opt2Js">'+vars_opt2+'</select></td>';
        }
        if (vars_opt3 !== '') {
          html += '<td class="hide-sm" data-title="'+$('#amShowUp th').eq(3).text()+'"><select class="product-loop-variants" data-opt="Opt3Js">'+vars_opt3+'</select></td>';
        }
        html += '<td class="qtt-wrapper" data-title="Qty:">';
          html += '<div class="quantity">';
            html += '<div class="control">';
              html += '<a class="btn-number qtyminus quantity-minus" href="javascript:void(0)"></a>';
              if (activeVr.available) {
                html += '<input type="text" data-id="'+activeVr.id+'" data-price="'+activeVr.price+'" name="quantity" value="1" min="1" class="input-qty input-text qty text" size="4" pattern="[0-9]*">';
              }else{
                html += '<input type="text" data-id="'+activeVr.id+'" data-price="'+activeVr.price+'" name="quantity" value="0" min="0" max="0" class="input-qty input-text qty text" size="4" pattern="[0-9]*">';
              }
              html += '<a class="btn-number qtyplus quantity-plus" href="javascript:void(0)"></a>';
            html += '</div>';
          html += '</div>';
        html += '</td>';
        html += '<td class="price-wrapper" data-title="Price:">';
          html += '<span class="price">';
            html += '<ins class="ProductPrice-'+activeVr.id+'">'+theme.Currency.formatMoney(activeVr.price, theme.moneyFormat)+'</ins>';
            // if (activeVr.compare_at_price) {html += '<del class="ComparePrice-'+activeVr.id+'">'+theme.Currency.formatMoney(activeVr.compare_at_price, theme.moneyFormat)+'</del>';}
          html += '</span>';
        html += '</td>';
      html += '</tr>';
      $('#amShowUp .list-vrs').append(html);
      $('#amShowUp .product_type_group').removeClass('loading');
      if (theme.function.multiCurrency == true && cookieCurrency !== null && cookieCurrency !== shopCurrency) {
        Currency.convertAll(shopCurrency,cookieCurrency,'#amShowUp .list-vrs  span.money');
      }
    }
  }
  function init(formJS,url,crVr) {
    var formJS = formJS, vrId = parseInt(crVr);
    var html = '';
    html += '<div class="table-group">';
    html += '<table class="table m-0">';
      html += '<thead class="thead-light">';
        html += '<tr>';
          html += '<th scope="col" class="text-center">#</th>';
          html += '<th scope="col" class="nameOption1"></th>';
          html += '<th scope="col" class="nameOption2" style="display: none"></th>';
          html += '<th scope="col" class="nameOption3" style="display: none"></th>';
          html += '<th scope="col">Qty</th>';
          html += '<th scope="col">Price</th>';
        html += '</tr>';
      html += '</thead>';
      html += '<tbody class="list-vrs">';
      html += '</tbody>';
      html += '<tfoot>';
        html += '<tr class="buttonAddmore">';
          html += '<td colspan="6" class="text-center"><i class="fa fa-plus btn-addmore" aria-hidden="true" data-vrid="'+vrId+'"></i>';
          html += '<a href="javascript:void(0)" class="btn btn-primary product_type_group add_to_cart_button ajax_add_to_cart loading" onclick="$(this).addClass(\'loading\').removeClass(\'loaded\');Shopify.KT_addItemFromFormAddMore(\'#amShowUp\')" style="width: 100%;margin-top: 10px;">'+theme.strings.addToCart+'</a>';
          html += '</td>';
        html += '</tr>';
      html += '</tfoot>';
    html += '</table>';
    html += '</div>';
    $.ajax({
      url: url+'.js',
      type: 'GET',
      dataType: 'JSON'
    })
    .done(function(data) {
      // console.log("success");
      var prVrs = data.variants;
      $('#amShowUpJSON').attr('data-pr-vrs',JSON.stringify(prVrs));
      $('#amShowUp').find('.nameOption1').text(data.options[0].name);
      if(data.options[1]){
        $('#amShowUp').find('.nameOption2').text(data.options[1].name).show();
      }
      if(data.options[2]){
        $('#amShowUp').find('.nameOption3').text(data.options[2].name).show();
      }
      buildSelect(prVrs,vrId);
    })
    .fail(function() {
      console.log("error");
    })
    .always(function() {
      // console.log("complete");
    });
    return html;
  }
  return {
    init: init,
    buildSelect: buildSelect
  };
})();

theme.menuBgChange = (function(){
  $(document).on('mouseenter','a.bgChange',function(event){
    event.preventDefault();
    var image = $(this).attr('data-hover-image');
    var content = $(this).attr('data-hover-banner');
    if(image !== undefined || content !== undefined ){
      $(this).parents('.sub-menu.megamenu').addClass('hiddenBg');    
      if($(this).parents('.sub-menu.megamenu').find('.imgByCollection').length == 0){
        if(image !== undefined){
          $(this).parents('.sub-menu.megamenu').append('<img class="imgByCollection" src="'+image+'" >');
        }else{
          $('.imgByCollection').remove();
          $(this).parents('.sub-menu.megamenu').append(content);
        }
      }else{
        $('.sub-menu.megamenu a.img-cate').remove();
        if(image !== undefined){
          $('.imgByCollection').show();
          $(this).parents('.sub-menu.megamenu').find('.imgByCollection').attr('src',image);
        }else{
          $('.imgByCollection').hide();
          $(this).parents('.sub-menu.megamenu').append(content);
        }
      }
    }
  })
  .on('mouseleave','a.bgChange',function(event){
    $(this).parents('.sub-menu.megamenu').removeClass('hiddenBg');
    $('.imgByCollection').hide();
    $('.sub-menu.megamenu a.img-cate').hide();
  });
});

theme.checkProductGrid_Width = (function(){
  // $('.quickshopForm').each(function(){
  //   var parentHeight = $(this).parents('.product-item').find('.product-thumb').height();
  //   $(this).parents('.product-item').addClass('normalQuickshop');
  //   $(this).css('max-height',parentHeight);
  // });
  $('div.product-item:not(.showUp)').each(function(){
    if ($(this).is(':visible')) {
      var parentWidth = $(this).width();
      if(parentWidth < 230){
        $(this).addClass('smallCard').removeClass('normalCard');
      }
      else{
        $(this).addClass('normalCard').removeClass('smallCard');
      }
    }
  });
});
theme.Quantity = (function(){
  $(document).on('click', '.quantity-up, .qtyplus',function() {
    var spinner = $(this).closest('.quantity'),
        input = spinner.find('input.input-qty'),
        min = input.attr('min') || 0,
        max = input.attr('max');
    var oldValue = parseFloat(input.val());
    if (oldValue >= max) {
      var newVal = oldValue;
    } else {
      var newVal = oldValue + 1;
    }
    input.val(newVal).trigger("change");
  });
  $(document).on('click', '.quantity-down, .qtyminus',function() {
    var spinner = $(this).closest('.quantity'),
        input = spinner.find('input.input-qty'),
        min = input.attr('min') || 0,
        max = input.attr('max');
    var oldValue = parseFloat(input.val());
    if (oldValue <= min) {
      var newVal = oldValue;
    } else {
      var newVal = oldValue - 1;
    }
    input.val(newVal).trigger("change");
  });
  $(document).on('change', '.quantity input.input-qty', function(){
    var input = $(this),max = input.attr('max');
    if( parseFloat(input.val()) > parseFloat(max) ){
      input.val(parseFloat(max)).trigger("change");
    }
  });
});

theme.initPhotoSwipeFromDOM = (function(gallerySelector, elcloned, tgName, callback){
  $('.pswp').removeAttr('style');
  // loop through all gallery elements and bind events
  var galleryElements = $( gallerySelector );
  // parse slide data (url, title, size ...) from DOM elements 
  // (children of gallerySelector)
  var parseThumbnailElements = function(el) {
    // build items array
    var itemsArray = $(el).find(elcloned+' [data-size]');
    var items = [];
    _.forEach(itemsArray, function(elItem, idx) {
      var item = new Object();
      item['src'] = $(elItem).attr('data-srcfix');
      item['w'] = $(elItem).attr('data-size').split('x')[0];
      item['h'] = $(elItem).attr('data-size').split('x')[1];
      items.push(item)
    });
    return items;
  };

  // find nearest parent element
  var closest = function closest(el, fn) {
    return el && ( fn(el) ? el : closest(el.parentNode, fn) );
  };

  // triggers when user clicks on thumbnail
  var onThumbnailsClick = function(e) {
    e = e || window.event;
    e.preventDefault ? e.preventDefault() : e.returnValue = false;

    var eTarget = e.target || e.srcElement;

    // find root element of slide
    var clickedListItem = closest(eTarget, function(el) {
      return (el.tagName && el.tagName.toUpperCase() === tgName);
    });
    if(!clickedListItem) {
      return;
    }

    // find index of clicked item by looping through all child nodes
    // alternatively, you may define index via data- attribute
    var clickedGallery = $(clickedListItem).parents(gallerySelector),
        childNodes = clickedGallery.find(elcloned+' [data-size]'),
        numChildNodes = childNodes.length,
        nodeIndex = 0,
        index;

    for (var i = 0; i < numChildNodes; i++) {
      if(childNodes[i] === clickedListItem) {
        index = nodeIndex;
        break;
      }
      nodeIndex++;
    }
    if(index >= 0) {
      // open PhotoSwipe if valid index found
      openPhotoSwipe( index, clickedGallery );
    }
    return false;
  };

  var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
    var pswpElement = $('.pswp')[0],
        gallery,
        options,
        items;

    items = parseThumbnailElements(galleryElement);

    // define options (if needed)
    options = {
      // history & focus options are disabled
      history: false,
      focus: false,

      // define gallery index (for URL)
      galleryUID: $(galleryElement).attr('data-pswp-uid'),

      getThumbBoundsFn: function(index) {
        // See Options -> getThumbBoundsFn section of documentation for more info
        var thumbnail = $(galleryElement).find(elcloned+' [data-size]')[index], // find thumbnail
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect(); 

        return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
      },
      shareButtons: [
        {id:'facebook', label:'Share on Facebook', url:'https://www.facebook.com/sharer/sharer.php?u={{url}}'},
        {id:'twitter', label:'Tweet', url:'https://twitter.com/intent/tweet?text={{text}}&url={{url}}'},
        {id:'pinterest', label:'Pin it', url:'http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}'}
      ]

    };

    // PhotoSwipe opened from URL
    if(fromURL) {
      if(options.galleryPIDs) {
        // parse real index when custom PIDs are used 
        // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
        for(var j = 0; j < items.length; j++) {
          if(items[j].pid == index) {
            options.index = j;
            break;
          }
        }
      } else {
        // in URL indexes start from 1
        options.index = parseInt(index, 10) - 1;
      }
    } else {
      options.index = parseInt(index, 10);
    }

    // exit if index not found
    if( isNaN(options.index) ) {
      return;
    }

    if(disableAnimation) {
      options.showAnimationDuration = 0;
    }
    
    // Pass data to PhotoSwipe and initialize it
    gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
    gallery.init();
    gallery.listen('afterChange', function() {
      callback(gallery.getCurrentIndex(),gallery.currItem)
    });
  };

  for(var i = 0, l = galleryElements.length; i < l; i++) {
    galleryElements[i].setAttribute('data-pswp-uid', i+1);
    galleryElements[i].onclick = onThumbnailsClick;
  }
})

theme.imgs360 = (function(files,position,width,height,vrId) {
  var totalFrames = position[1] - position[0];
  var myModalThreeSixty = '<section class="modal animated fadeIn myModalThreeSixty kt_'+vrId+'" data-vr-id="'+vrId+'" data-total-frames="'+totalFrames+'" data-end-frames="'+totalFrames+'" data-files="'+files+'" data-width="'+width+'" data-height="'+height+'" aria-hidden="false" role="dialog" tabindex="-1"> <div class="modal-dialog modal-lg"> <div class="modal-content"> <button class="close animate"> <span aria-hidden="true">×</span> </button> <div class="content-item"> <div class="threesixty productThreeSixty"> <div class="spinner"> <span>0%</span> </div><ol class="threesixty_images"></ol> </div></div></div></div></section>';
  $('body').append(myModalThreeSixty);
  $(document).on('click','button.kt_open360_'+vrId,function(e){
    $('.myModalThreeSixty.kt_'+vrId).modal();
    var dataJs = $('.myModalThreeSixty.kt_'+vrId);
    var options = {
      totalFrames: dataJs.attr('data-total-frames'),
      endFrame: dataJs.attr('data-end-frames'), 
      currentFrame: 1, 
      imgList: '.threesixty_images', 
      progress: '.spinner',
      imgArray: dataJs.attr('data-files').split(','),
      width: dataJs.attr('data-width'),
      height: dataJs.attr('data-height'),
      responsive: true,
      navigation: true
    }
    $('.myModalThreeSixty.kt_'+dataJs.attr('data-vr-id')+' .productThreeSixty').ThreeSixty(options);
  });
  $(document).on('click','button.close.animate',function(e){
    $(this).closest('.myModalThreeSixty').addClass('fadeOut').animate({opacity: 0}, 400, function(){
      $('.myModalThreeSixty.kt_'+vrId).removeClass('fadeOut').modal('hide')
    });
  });
  $('.myModalThreeSixty.kt_'+vrId).on('hidden.bs.modal', function () {
    $('.productThreeSixty').find('.nav_bar_stop').trigger('click')
  })
})

theme.scrollbarCategory = (function(el){
  var $elx = $(el).find('.categorys-menu.overx .category-menu');
  $elx.mCustomScrollbar({
    axis:"x",
    theme:"dark-thin",
    autoHideScrollbar:true,
    scrollInertia: 300
  });
  var $ely = $(el).find('.categorys-menu.overy .category-menu');
  $ely.mCustomScrollbar({
    axis:"y",
    theme:"dark-thin",
    autoHideScrollbar:true,
    scrollInertia: 300
  });
})

window.theme = theme || {};
theme.cookiesPopup = (function() {
  function init(container) {
    var popup = $('.kt-cookies-popup');
    setTimeout(function() {
      popup.addClass('popup-display');
      popup.on('click', '.cookies-accept-btn', function(e) {
        e.preventDefault();
        acceptCookies();
      })
    }, 2500);

    var acceptCookies = function() {
      popup.removeClass('popup-display').addClass('popup-hide');
      localStorage.setItem("kt_cookies", "accepted")
    };
    if(localStorage.getItem("kt_cookies") == 'accepted') {
      popup.removeClass('popup-display').addClass('popup-hide');
    }
  }
  return init;
})();
theme.cookiesPopup.prototype = _.assignIn({}, theme.cookiesPopup.prototype, {
  onSelect: function(evt) {
    localStorage.removeItem("kt_cookies");
    $('.kt-cookies-popup').addClass('popup-display').removeClass('popup-hide');
  }
});

window.theme = theme || {};
theme.lookBook = (function() { 
  function lookBook(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    if(product_handle !== null){
      $.ajax({
        url: '/products/'+product_handle+'?view=lookbook',
        type: 'GET',
        dataType: 'html'
      })
      .done(function(data) {
        // console.log("success");
        var dataJs = $.parseJSON(data.split('/kiti')[1]);
        _.forEach(dataJs, function(item) {
          if(item.id === product_handle){
            if($('[alt="'+item.handle+'"]').length){
              $('[alt="'+item.handle+'"]').each(function(){
                var self = $(this);
                var pin = '', parent_pin = self.parent();
                parent_pin.find('.kt_pins').length <= 0 ? parent_pin.append('<div class="kt_pins"></div>') : parent_pin.find('.kt_pins').html('');
                _.forEach([1, 2, 3, 4, 5], function(value) {
                  var top_pin = 'top_pin_' + value,
                      left_pin = 'left_pin_' + value,
                      size_ = 'size_' + value,
                      background = 'bg_' + value,
                      handle = 'id_' + value;
                  if(item[handle] !== ''){
                    var top = item[top_pin] - ((item[size_] / 2) / self.height() * 100), left = item[left_pin] - ((item[size_] / 2) / self.width() * 100) ;
                    pin += '<div class="button kt_pin" data-product-handle="'+item[handle]+'" style="top: '+ top +'%;left: '+ left +'%;width: '+item[size_]+'px;height: '+item[size_]+'px;line-height: '+item[size_]+'px; background-color: '+item[background]+'">';
                    pin += '<span class="kt_pin_name">+</span>';
                    pin += '</div>';
                    loadpr_lookBook(item[handle])
                  }
                });
                self.parent().addClass('kt_pin_item').find('.kt_pins').html(pin)
              });
            }
          }
        });
      })
      .fail(function() {
        console.log("error lookbook-product-single");
      })
      .always(function() {
        theme.clickProductPopup.init('.kt_pin a.quickshopMiniList');
      });
    }
  }
  function loadpr_lookBook(handle) {
    $.ajax({
      url: '/products/'+handle+'?view=miniListJs',
      type: 'GET',
      dataType: 'html'
    })
    .done(function(data) {
      var prJs = data;
      var info = '';
          info += '<div class="kt_pin_pritem">';
          info += data;
          info += '</div>';
      $('.kt_pin[data-product-handle="'+handle+'"]:not(.loaded)').addClass('loaded').append(info);
      theme.DropdownReposive.init('.kt_pins','.kt_pin','.kt_pin_pritem');
    });
  }
  return lookBook;
})();

$(document).ready(function() {
  var sections = new theme.Sections();
  sections.register('banner-page-section',theme.BannerByPage);
  sections.register('cart-template', theme.Cart);
  sections.register('product', theme.Product);
  sections.register('collection-template', theme.Filters);
  sections.register('map', theme.Maps);
  if ($('[data-section-type="carousel-section"]').length > 0) {
    KT.loadScript('owl-carousel', function(e,l){
      if (l == 'ok') {
        sections.register('carousel-section', theme.CarouselSection);
      }
    })
  }
  sections.register('masonry-section', theme.MasonrySection);
  sections.register('instagram-section', theme.Instagram);
  sections.register('banner-section', theme.BannerSection);
  sections.register('quotes', theme.Quotes);
  sections.register('kt-cookies', theme.cookiesPopup);
  theme.stockCountdown.init('.product-page .kt_progress_bar_pr');
  theme.variantChange();
  theme.menuBgChange();  
  theme.TabOwlFadeEffect();
  theme.TabProductFadeEffect();
  theme.Quantity();
  theme.clickOnScrollButton();
  if ($('[data-section-type="collection-template"]').length > 0) {
    KT.loadScript('pjax', function(e,l){
      if (l == 'ok') {
        theme.FiltersPjax();
      }
    })
  }
});

$(window).load(function() {
  theme.MenuReposive.clone_main_menu();
  if ($('[data-section-id="header"]').data('sticky') === true && $('#header-ontop').length > 0) {
    theme.MenuReposive.clone_header_ontop();
  } else {
    theme.Carousel.init($('[data-section-id="header"]')[0],true)
  }
  theme.MenuReposive.js_height_full();
  theme.MenuReposive.js_width_full();
  theme.MenuReposive.js_right_follow('#header');
  theme.DropdownReposive.init('.kiti--DropWindow','.kiti--DropItem','.kiti--DropInner');
  theme.DropdownReposive.init('#ProductSection-product-template .fake_select>ul','.color_sw','.title');
  KT.loadScript('tippy', function(e,l){});  
});

$(window).on("resize", function() {
  $(".nowrap-follow-right").children().removeAttr('style');
  if($('#header-ontop .ResizedNavMegaScroll').length > 0){
    $('#header-ontop .ResizedNavMegaScroll').removeClass('ResizedNavMegaScroll')
  }
  if($('.kt_layerfilterGroupsMobile').length > 0){
    if ($(window).width() >= 768 && $('.kt_layerfilterGroupsMobile').html() != ''){
      $('.kt_layerfilterGroupsDesktop').html($('.kt_layerfilterGroupsMobile').html())
    }
    else if($(window).width() < 768 && $('.kt_layerfilterGroupsDesktop').html() != ''){
      $('.kt_layerfilterGroupsMobile').html($('.kt_layerfilterGroupsDesktop').html())
    }
  }
  theme.Carousel.initCarouselMobile();
  theme.ResizeNavMega.init();
  theme.MenuReposive.clone_main_menu();
  setTimeout(function(){
    theme.MenuReposive.js_right_follow('#header');
  },300)
  if ($('[data-section-id="header"]').data('sticky') === true && $('#header-ontop').length > 0) {
    theme.ResizeNavMega.init('header-ontop');
    theme.MenuReposive.clone_header_ontop();
  }
  theme.MenuReposive.js_height_full();
  theme.MenuReposive.js_width_full();
  theme.DropdownReposive.init('.kiti--DropWindow','.kiti--DropItem','.kiti--DropInner');
  theme.DropdownReposive.init('#ProductSection-product-template .fake_select>ul','.color_sw','.title');  
  theme.DropdownReposive.init('.drop-resp__grid-list','.color_sw','.title');
  theme.checkProductGrid_Width();
});

$(window).scroll(function(){
  theme.clickOnScrollButton();
});
document.addEventListener("DOMContentLoaded", function(event) {
  theme.checkProductGrid_Width();
  var sections = new theme.Sections();
  sections.register('header-section', theme.HeaderSection);
  sections.register('masory-section', theme.ProductsMasorySection);
  sections.register('bt_banner_masonry',theme.BannerMasorySection.MasorySection);
});
theme.init = function() {
  theme.customerTemplates.init();

  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on('click', function(evt) {
    evt.preventDefault();
  });
  // $('[data-toggle="tooltip"]').tooltip({
  //   trigger: 'hover'
  // })
  if (window.adminCollFunction) {
    adminCollFunction();
  }
};

$(theme.init);